<template>
  <div id="app"
       :class="{
			'nav-spacing':$router.currentRoute.path !== '/',
		    'bottom-nav-spacing': $router.currentRoute.path !== '/',
		    'is-web': $config.IS_WEB_VERSION,
		    'ios': isiOS
	}">
    <navigation v-if="$router.currentRoute.path !== '/'"
                :user="user"
    >

      <router-link v-if="$router.currentRoute.path !== '/menu'" to="/menu">
        <img style="max-width: 2.2em" src="@/img/profile.svg" alt="profile">
      </router-link>
      <img v-else
           style="max-width: 1.5em; margin-right: 5px;"
           src="@/img/close_menu.png"
           @click="$router.back()"
           alt="close">
    </navigation>

    <router-view v-if="mounted" @process-img="processImage"/>

    <div v-if="$store.state.fetchPending" class="pending-layer">
      <img src="@/img/hensel-loading.svg" alt="loading">
    </div>

    <bottom-navigation v-if="$router.currentRoute.path !== '/'" :routes="bottomNavRoutes"/>

    <modal :visible="!latestErrorHidden"
           @positive-response="$store.commit('setLatestError', {code:'',message:'',hidden: true});"
    >
      <p>{{ latestError.message }}</p>
    </modal>

    <modal :visible="!!modalConverter"
           :positive-button="_('Löschen')"
           :negative-button="_('Abbrechen')"
           @positive-response="removeFromInventory"
           @negative-response="hideConfirmationModal"
    >
      <p v-if="modalConverter" v-html="sprintf(_('Wollen Sie <b>%s</b> wirklich aus Ihrer Merkliste löschen?'), translateConverter(modalConverter))"></p>
    </modal>

    <modal :visible="user && !user.privacy_accepted"
           :title="_('Terms of Use')"
           :positive-button="_('Accept Terms')"
           @positive-response="tryAcceptTerms"
    >
      <bulma-accordion>
        <bulma-accordion-item>
          <h4 slot="title" style="padding-right: .5em">Terms of Use for Downloading and for Using the
            Catalogue
            App</h4>
          <div slot="content">
            <h3>Declaration</h3>
            <p>I hereby consent to Hensel Recycling GmbH (“HR”) collecting, processing and using information
              about my use of this Catalogue-App. Said information includes my user name. HR shall treat
              this information confidentially and will not disclose it to third parties. This will not
              apply if HR is obligated to disclose the data by law or in the context of court
              proceedings.</p>
            <p>I am aware that HR will use the data collected for the following purposes:</p>
            <ul>
              <li>To combat misuse, in particular to trace any data theft and any unauthorised disclosure
                of access data (user name and password);
              </li>
              <li>To improve customer contact, in particular by logging the type and number of catalysts
                in which an interest is shown;
              </li>
              <li>To improve the website.</li>
            </ul>
            <p>I may revoke this consent at any time in writing with forward effect. I may demand that the
              data already collected be erased or blocked, provided such data is not needed in any
              on-going business relationship, and provided doing so does not incur unreasonable time and
              cost on HR.</p>

            <h3>Privacy Statement pursuant to the General Data Protection Regulation (GDPR)</h3>

            <p>1. Name and address of the controller<br/>
              The controller within the meaning of the General Data Protection Regulation and other
              national data protection laws of the member states, as well as other data protection rules,
              is:</p>

            <p>Hensel Recycling GmbH<br/>
              Mühlweg 10<br/>
              D-63743 Aschaffenburg<br/>
              Germany<br/>
              Tel.: +49 6028 1209-0<br/>
              Email: info@hensel-recycling.com<br/>
              Website: www.hensel-recycling.com</p>

            <p>In the following, we provide you with information about the processing of your personal data
              within the context of the use of our website. Should you have any further questions relating
              to data protection in connection with our website or the services offered, please contact
              our data protection officer.<br/>
              The data protection officer for the controller is:</p>

            <p>Rudolf Fiedler<br/>
              DPP Data Protection GmbH<br/>
              E-Mail: datenschutz@hensel-recycling.com</p>

            <p>2. Scope, purpose and legal basis for the processing of personal data<br/>
              In principle, we collect and use the personal data of our users only to the extent necessary
              to provide a functional website, as well as our content and services. The collection and use
              of the personal data of our users is carried out on a regular basis only with the consent of
              the user. An exception applies in those cases in which for reasons of fact it is not
              possible to obtain prior consent and the processing of the data is permitted by law.</p>

            <p>2.1 Creation of log files<br/>
              Every time our website is accessed, our system automatically captures data and information
              from the computer system of the requesting computer.<br/>
              The following data (“technical information”) is collected:</p>

            <p>&nbsp;&nbsp;&nbsp; • Information about the browser type and the version used<br/>
              &nbsp;&nbsp;&nbsp; • The user’s operating system<br/>
              &nbsp;&nbsp;&nbsp; • The user’s Internet service provider<br/>
              &nbsp;&nbsp;&nbsp; • The user’s IP address in anonymous form<br/>
              &nbsp;&nbsp;&nbsp; • Date and time of access<br/>
              &nbsp;&nbsp;&nbsp; • Websites from which the user’s system linked to our website<br/>
              &nbsp;&nbsp;&nbsp; • Websites, which are called up by the user’s system via our website</p>

            <p>The data is also stored in our system’s log files. The user’s IP addresses or other data,
              which allow the data to be related to a user, are not affected. This data is not stored with
              other personal data relating to the user. We process this technical information for the
              purpose of network security in order, for example, to combat any attacks, for marketing
              purposes to better understand the requirements of our users, and to improve our website
              offering. Our legitimate interest in data processing pursuant to Art. 6 (1) point f GDPR is
              also for this purpose. The collection of data for the provision of the website and to store
              the data in log files is necessary for the operation of the website. Therefore, the user has
              no right to object.</p>

            <p>2.2 Use of cookies<br/>
              Our website uses cookies. Cookies are text files, which are stored in the Internet browser
              or by the Internet browser on the user’s computer system. If a user calls up a website, a
              cookie can be stored on the user’s operating system. This cookie contains a characteristic
              string, which allows the browser to be clearly identified when the website is called up
              again. We use cookies to make our website more user friendly. Some elements of our website
              need the visiting browser to be able to be identified even after switching pages. On our
              website we also use cookies that allow the surfing behaviour of the users to be analysed.
              Technical means are used to pseudonymous the user’s data collected in this way. For this
              reason, the data can no longer be related to the calling user. The data is not stored with
              the user’s other personal data. When the user visits our website, an info banner informs him
              about the use of cookies for analytical purposes and refers him to this privacy statement.
              When the user visits our website, he is informed about the use of cookies for analytical
              purposes and his consent to the processing of personal data used in this context is
              obtained. Reference is also made in this context to this privacy statement. Technically
              necessary cookies are used to simplify the use of websites for the user. Some features of
              our website cannot be provided without the use of cookies. These features require that the
              browser also be recognised after switching pages. The data collected by technically
              necessary cookies are not used to create user profiles. Analytical cookies are only used to
              improve the quality of our website and its contents. The analytical cookies show us how the
              website is used which in turn enables us to continually optimise our offering. Our
              legitimate interest in the processing of the personal data and the legal basis pursuant to
              Art. 6 (1) point f GDPR is for this purpose. Cookies are stored on the user’s computer and
              transmitted by the computer to our website. This means that you as the user also have full
              control over the use of cookies. By changing the settings in your Internet browser, you can
              disable or restrict the transmission of cookies. Any cookies already stored can be deleted
              at any time. This can also be done automatically. If cookies for our website are disabled,
              it is possible that not all the features of the website will be able to be used to the full
              extent.</p>

            <p>2.1 Registration<br/>
              On our website, we give users the opportunity to register by entering their personal data.
              The data is entered into an input mask, transmitted to us and stored. The data is not passed
              on to third parties. The following data is collected during the registration process:<br/>
              At the time of registration, the following data is also stored:</p>

            <p>&nbsp;&nbsp;&nbsp; • The user’s IP address<br/>
              &nbsp;&nbsp;&nbsp; • Date and time of registration</p>

            <p>During the registration process, the user’s consent to process this data is obtained. It is
              necessary for the user to register to access specific content and services on our website.
              When the user’s consent has been obtained, the legal basis for the processing of data is
              Art. 6 (1) point a GDPR.</p>

            <p>2.2 Contact form<br/>
              A contact form on our website can be used to make contact electronically. If a user makes
              use of this option, the data entered in the input mask is transmitted to us and stored. This
              data includes:<br/>
              At the time the message is sent, the following data is also stored:</p>

            <p>&nbsp;&nbsp;&nbsp; • The user’s IP address<br/>
              &nbsp;&nbsp;&nbsp; • Date and time of registration</p>

            <p>During the send operation, your consent is obtained for the processing of data and you are
              referred to this privacy statement. It is also possible to make contact using the email
              address provided. In this case, the user’s personal data that was transmitted with the email
              is stored. In this connection, no data is passed on to third parties. The data is only used
              to process the conversation. We only use the processing of personal data from the input mask
              to process the establishing of contact. Where contact is made by email, we also have a
              legitimate interest in processing the data. The other personal data processed during the
              send operation is used to prevent the contact form from being misused and to ensure the
              security of our information technology systems. When the user’s consent has been obtained,
              the legal basis for the processing of data is Art. 6 (1) point a GDPR. The legal basis for
              processing data which has been transmitted during the sending of an email is Art. 6 (1)
              point f GDPR. If the email contact is aimed at concluding a contract, Art. 6 (1) point b
              GDPR constitutes an additional legal basis. The data is deleted as soon as it is no longer
              required to realise the purpose of its collection. This is the case for personal data from
              the input mask of the contact form and personal data sent by email when the respective
              conversation with the user is concluded. The conversation is concluded when it can be
              inferred from the circumstances that the situation in question is definitively resolved. The
              user may at any time withdraw his consent to the processing of personal data with effect for
              the future. If the user contacts us by email, he may object to the storing of his personal
              data at any time. In this case, the conversation cannot be continued. All personal data
              which were stored in the course of making contact are deleted in this case.</p>

            <p>2.3 Tracking tools<br/>
              On our website, we use Google Analytics as the tracking and website analysis tool. The
              purpose is to increase the efficiency of our website and our direct marketing. On our App,
              we use Matomo as the tracking and analysis tool. The purpose is to increase the efficiency
              of our App as well as the display of the inventory. These tools are operated by third-party
              providers and require data to be transmitted via the website user. The legal basis for the
              use of website analytics is Art. 6 (1) point f GDPR.</p>

            <p>2.4 Social media plug-ins<br/>
              We use the following social media plug-ins on our website:</p>

            <p>&nbsp;&nbsp;&nbsp; • LinkedIn<br/>
              &nbsp;&nbsp;&nbsp; • XING</p>

            <p>The basic provision of the plug-ins on our website arises from our legitimate interest for
              marketing purposes from Art. 6 (1) point f GDPR.</p>

            <p>3. Legal basis for processing personal data<br/>
              Insofar as we obtain consent for processing personal data from the data subject, Art. 6 (1)
              point a of the EU General Data Protection Regulation (GDPR) serves as the legal basis for
              the processing of personal data. For the processing of personal data which is necessary for
              the performance of a contract to which the data subject is party, Art. 6 (1) point b GDPR
              serves as the legal basis. This also applies to processing which is necessary for the
              implementation of pre-contractual measures. Insofar as processing of personal data is
              necessary for the fulfilment of a legal obligation to which our company is subject, Art. 6
              (1) point c GDPR serves as the legal basis. In the event that vital interests of the data
              subject or another natural person make it necessary to process personal data, Art. 6 (1)
              point d GDPR serves as the legal basis. If processing is necessary to safeguard a legitimate
              interest of our company or of a third party, and if the interests, basic rights and basic
              freedoms of the data subject do not prevail over the interest first mentioned, Art. 6 (1)
              point f GDPR serves as legal basis for the processing. In this case, along with the purposes
              set out above, our legitimate interests are:</p>

            <p>&nbsp;&nbsp;&nbsp; • To protect the company from material or immaterial damage<br/>
              &nbsp;&nbsp;&nbsp; • To professionalise our products and services<br/>
              &nbsp;&nbsp;&nbsp; • To optimise costs</p>

            <p>Furthermore, we process personal data in order to comply with data retention requirements
              under commercial law or tax law. In the input masks on our website we have indicated which
              input fields are required to be completed by you to meet statutory or contractual
              requirements so that we are able to provide the service you require.</p>

            <p>4. Data erasure and storage period<br/>
              The personal data of the data subject is erased or blocked as soon as the purpose of the
              storage ceases to exist or is no longer necessary. At the same time, it is possible for
              personal data to be retained for the period in which claims against our company can be
              asserted (statutory periods of limitation can be from three to thirty years). Data may also
              be stored beyond that if provided for by the European or national legislator in regulations,
              laws or provisions laid down by the legislation of the Union to which the controller is
              subject. Appropriate obligations to provide evidence and to retain data arise inter alia
              from the German Commercial Code, German Fiscal Code and the German Money Laundering Act. On
              this basis, the storage periods are up to ten years. Data is blocked or erased even if a
              storage period prescribed by the specified norms expires, unless there is a necessity to
              continue to store the data for the conclusion or the fulfilment of a contract.</p>

            <p>5. Right to object according to Art. 21 GDPR<br/>
              You shall have the right to object, on grounds relating to your particular situation, at any
              time to processing of personal data concerning you which is based on point (e) or (f) of
              Article 6(1), including profiling based on those provisions. The controller shall no longer
              process the personal data unless the controller demonstrates compelling legitimate grounds
              for the processing which override the interests, rights and freedoms of the data subject or
              for the establishment, exercise or defence of legal Claims Where personal data is processed
              for direct marketing purposes, you shall have the right to object at any time to processing
              of personal data concerning you for such marketing, which includes profiling to the extent
              that it is related to such direct marketing. If you object to processing for direct
              marketing purposes, the personal data shall no longer be processed for such purposes. In the
              context of the use of information society services, and notwithstanding Directive
              2002/58/EC, you may exercise your right to object by automated means using technical
              specifications.</p>

            <p>6. Rights of the data subject<br/>
              It is important to our company that our processes for processing personal data are
              transparent. For this reason, we make you aware that as well as the right to object, you are
              able to exercise further rights if the appropriate statutory requirements are met:</p>

            <p>&nbsp;&nbsp;&nbsp; • Right of access by the data subject according to Art.15 GDPR<br/>
              &nbsp;&nbsp;&nbsp; • Right to rectification in accordance with Art.16 GDPR<br/>
              &nbsp;&nbsp;&nbsp; • Right to erasure (“right to be forgotten”) in accordance with Art.17
              GDPR<br/>
              &nbsp;&nbsp;&nbsp; • Right to restriction of processing in accordance with Art.18 GDPR<br/>
              &nbsp;&nbsp;&nbsp; • Notification obligation in accordance with Art.19 GDPR<br/>
              &nbsp;&nbsp;&nbsp; • Right to data portability in accordance with Art.20 GDPR<br/>
              &nbsp;&nbsp;&nbsp; • (no) automated individual decision-making, including profiling in
              accordance with Art.21 GDPR</p>

            <p>To safeguard your rights, you can send an email to datenschutz@hensel-recycling.com. In order
              to process your application and for identification purposes, we make you aware that we
              process your personal data in accordance with Art. 6 (1) point c GDPR.</p>

            <p>7. Consent<br/>
              You have the right to withdraw your declaration of consent under data protection law at any
              time with effect for the future. The withdrawal of consent shall not affect the lawfulness
              of processing based on consent before its withdrawal. In some cases, we are entitled despite
              the withdrawal to continue to process your personal data on a different legal basis (to
              fulfil a contract).</p>

            <p>8. Right to lodge a complaint with a supervisory authority<br/>
              Without prejudice to any other administrative or judicial remedy, you have the right to
              lodge a complaint with a supervisory authority, in particular in the Member State of your
              habitual residence, place of work or place of the alleged infringement if you consider that
              the processing of personal data relating to you infringes the GDPR. The supervisory
              authority with which the complaint has been lodged shall inform the complainant on the
              progress and the outcome of the complaint, including the possibility of a judicial remedy,
              pursuant to Article 78 GDPR.</p>

            <p>Competent supervisory authority:<br/>
              Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)<br/>
              Promenade 27<br/>
              D-91522 Ansbach</p>


          </div>
        </bulma-accordion-item>
        <bulma-accordion-item>
          <h4 slot="title" style="padding-right: .5em">Nutzungsbedingung für den Download und die Verwendung
            der Katalog-App</h4>
          <div slot="content">
            <h3>Erklärung</h3>

            <p>Ich stimme hiermit zu, dass die Hensel Recycling GmbH (kurz HRD) Informationen über meine
              Benutzung dieser Katalog-App erhebt, verarbeitet und nutzt. Diese Informationen schließen
              meinen Benutzernamen ein. Die HRD wird diese Daten vertraulich behandeln und nicht an Dritte
              weitergeben. Dies gilt nicht, wenn die HRD zur Weitergabe der Daten gesetzlich oder im
              Rahmen eines Gerichtsverfahrens verpflichtet ist.</p>

            <p>Mir ist bekannt, dass die HRD die erfassten Daten zum Zwecke der</p>

            <p>- Missbrauchsbekämpfung, insbesondere der Verfolgung von Datendiebstählen und der
              unberechtigten Weitergabe der Zugangsdaten (Benutzername und Kennwort);<br/>
              -Verbesserung des Kundenkontakts, insbesondere durch Erfassen von Art und Anzahl der
              interessierenden Katalysatortypen;<br/>
              - Verbesserung der App benutzen wird.</p>

            <p>Ich kann diese Einwilligung jederzeit schriftlich mit Wirkung für die Zukunft widerrufen. Ich
              kann das Löschen oder Sperren der bereits erhobenen Daten verlangen, sofern diese Daten
              nicht im Rahmen des laufenden Geschäftsverhältnisses notwendig sind und dies nicht einen
              unverhältnismäßigen Aufwand für die HRD bedeutet.</p>

            <h4>Nutzungsbedingung für den Download und die Verwendung der Katalog-App</h4>

            <p>1. Einleitung<br/>
              Die Inhalte dieser Katalog-App wurden von Hensel Recycling GmbH (nachfolgend HRD genannt)
              mit größter Sorgfalt zusammengestellt. Eine Garantie für die Vollständigkeit und Richtigkeit
              der Angaben können wir jedoch nicht übernehmen. HRD übernimmt daher keine Haftung für Fehler
              in den Inhalten. Durch den Zugriff akzeptieren Sie ohne Einschränkung oder Vorbehalt die
              nachstehenden Nutzungsbedingungen.</p>

            <p>2. Urheberrecht<br/>
              Sämtliche Abbildungen und Inhalte sind unser geistiges Eigentum und genießen
              urheberrechtlichen Schutz. Diese dürfen daher weder vervielfältigt, verbreitet, bearbeitet,
              übersetzt oder sonst in andere Medien eingespeichert oder verarbeitet werden, einschließlich
              solcher in elektronischer Form. Jede Verwendung der Inhalte bedarf der vorherigen
              schriftlichen Zustimmung der HRD. Die Nutzung der Katalog-App kann von HRD jederzeit ohne
              Angabe von Gründen widerrufen werden.</p>

            <p>3. Haftung<br/>
              Sämtliche zur Verfügung gestellten Informationen wurden nach bestem Wissen zusammengestellt
              – eine ständige Aktualisierung der Daten kann nicht gewährt werden. Ansprüche des Kunden auf
              Schadenersatz aufgrund falscher Angaben sind daher ausgeschlossen. Angebote und
              Auftragsbestätigungen, welche aufgrund falscher Kundenangaben gemacht wurden, verlieren Ihre
              Gültigkeit. Mit Zustimmung zu den Nutzungsbedingungen erklärt sich der Nutzer ausdrücklich
              damit einverstanden, dass zur endgültigen Wertbestimmung die Einstufung unseres Mitarbeiters
              entscheidend ist. Bei der Abrechnung von Katalysatoren anhand von Kategorien ist die
              Einstufung am Tag der Auftragserteilung gültig.</p>

            <h3>Datenschutzerklärung nach der DSGVO</h3>

            <p>1. Name und Anschrift des Verantwortlichen<br/>
              Der Verantwortliche im Sinne der Datenschutz-Grundverordnung und anderer nationaler
              Datenschutzgesetze der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen
              ist die:</p>

            <p>Hensel Recycling GmbH<br/>
              Mühlweg 10<br/>
              63743 Aschaffenburg<br/>
              Deutschland<br/>
              Tel.: +49 6028 1209-0<br/>
              E-Mail: info@hensel-recycling.com<br/>
              Website: <a href="http://www.hensel-recycling.com">www.hensel-recycling.com</a></p>

            <p>Wir informieren Sie im Folgenden über die Verarbeitung Ihrer personenbezogenen Daten im
              Rahmen der Nutzung unserer Webseite. Sollten Sie darüber hinaus Fragen zum Datenschutz im
              Zusammenhang mit unserer Webseite oder den angebotenen Services haben, kontaktieren Sie
              unseren Datenschutzbeauftragten.<br/>
              Der Datenschutzbeauftragte des Verantwortlichen ist:</p>

            <p>Rudolf Fiedler<br/>
              DPP Data Protection GmbH<br/>
              E-Mail: datenschutz@hensel-recycling.com</p>

            <p>2. Umfang, Zweck und Rechtsgrundlage der Verarbeitung personenbezogener Daten<br/>
              Wir erheben und verwenden personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit
              dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen
              erforderlich ist. Die Erhebung und Verwendung personenbezogener Daten unserer Nutzer erfolgt
              regelmäßig nur nach Einwilligung des Nutzers. Eine Ausnahme gilt in solchen Fällen, in denen
              eine vorherige Einholung einer Einwilligung aus tatsächlichen Gründen nicht möglich ist und
              die Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist.</p>

            <p>2.1 Erstellung von Logfiles<br/>
              Bei jedem Aufruf unserer Internetseite erfasst unser System automatisiert Daten und
              Informationen vom Computersystem des aufrufenden Rechners.<br/>
              Folgende Daten („technische Informationen“) werden hierbei erhoben:</p>

            <p>&nbsp;&nbsp;&nbsp; • Informationen über den Browsertyp und die verwendete Version<br/>
              &nbsp;&nbsp;&nbsp; • Das Betriebssystem des Nutzers<br/>
              &nbsp;&nbsp;&nbsp; • Den Internet-Service-Provider des Nutzers<br/>
              &nbsp;&nbsp;&nbsp; • Die IP-Adresse des Nutzers in anonymisierter Form<br/>
              &nbsp;&nbsp;&nbsp; • Datum und Uhrzeit des Zugriffs<br/>
              &nbsp;&nbsp;&nbsp; • Websites, von denen das System des Nutzers auf unsere Internetseite
              gelangt<br/>
              &nbsp;&nbsp;&nbsp; • Websites, die vom System des Nutzers über unsere Website aufgerufen
              werden</p>

            <p>Die Daten werden ebenfalls in den Logfiles unseres Systems gespeichert. Nicht hiervon
              betroffen sind die IP-Adressen des Nutzers oder andere Daten, die die Zuordnung der Daten zu
              einem Nutzer ermöglichen. Eine Speicherung dieser Daten zusammen mit anderen
              personenbezogenen Daten des Nutzers findet nicht statt. Dabei verarbeiten wir diese
              technischen Informationen zu Zwecken der Netzwerksicherheit um z.B. Angriffe bekämpfen zu
              können, zu Zwecken des Marketings, um die Anforderungen unserer Nutzer besser verstehen zu
              können und zur Verbesserung unseres Webseitenangebots. In diesen Zwecken liegt auch unser
              berechtigtes Interesse an der Datenverarbeitung nach Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f
              DSGVO. Die Erfassung der Daten zur Bereitstellung der Website und die Speicherung der Daten
              in Logfiles ist für den Betrieb der Internetseite zwingend erforderlich. Es besteht folglich
              seitens des Nutzers keine Widerspruchsmöglichkeit.</p>

            <p>2.2 Verwendung von Cookies<br/>
              Unsere Webeseite verwendet Cookies. Bei Cookies handelt es sich um Textdateien, die im
              Internetbrowser bzw. vom Internetbrowser auf dem Computersystem des Nutzers gespeichert
              werden. Ruft ein Nutzer eine Website auf, so kann ein Cookie auf dem Betriebssystem des
              Nutzers gespeichert werden. Dieser Cookie enthält eine charakteristische Zeichenfolge, die
              eine eindeutige Identifizierung des Browsers beim erneuten Aufrufen der Website ermöglicht.
              Wir setzen Cookies ein, um unsere Website nutzerfreundlicher zu gestalten. Einige Elemente
              unserer Internetseite erfordern es, dass der aufrufende Browser auch nach einem
              Seitenwechsel identifiziert werden kann. Wir verwenden auf unserer Website darüber hinaus
              Cookies, die eine Analyse des Surfverhaltens der Nutzer ermöglichen. Die auf diese Weise
              erhobenen Daten der Nutzer werden durch technische Vorkehrungen pseudonymisiert. Daher ist
              eine Zuordnung der Daten zum aufrufenden Nutzer nicht mehr möglich. Die Daten werden nicht
              gemeinsam mit sonstigen personenbezogenen Daten der Nutzer gespeichert. Beim Aufruf unserer
              Website werden die Nutzer durch einen Infobanner über die Verwendung von Cookies zu
              Analysezwecken informiert und auf diese Datenschutzerklärung verwiesen. Beim Aufruf unserer
              Website wird der Nutzer über die Verwendung von Cookies zu Analysezwecken informiert und
              seine Einwilligung zur Verarbeitung der in diesem Zusammenhang verwendeten personenbezogenen
              Daten eingeholt. In diesem Zusammenhang erfolgt auch ein Hinweis auf diese
              Datenschutzerklärung. Der Zweck der Verwendung technisch notwendiger Cookies ist, die
              Nutzung von Websites für die Nutzer zu vereinfachen. Einige Funktionen unserer Internetseite
              können ohne den Einsatz von Cookies nicht angeboten werden. Für diese ist es erforderlich,
              dass der Browser auch nach einem Seitenwechsel wiedererkannt wird. Die durch technisch
              notwendige Cookies erhobenen Nutzerdaten werden nicht zur Erstellung von Nutzerprofilen
              verwendet. Die Verwendung der Analyse-Cookies erfolgt zu dem Zweck, die Qualität unserer
              Website und ihre Inhalte zu verbessern. Durch die Analyse-Cookies erfahren wir, wie die
              Website genutzt wird und können so unser Angebot stetig optimieren. In diesen Zwecken liegt
              auch unser berechtigtes Interesse an der Verarbeitung der personenbezogenen Daten und auch
              die Rechtsgrundlage nach Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO. Cookies werden auf dem
              Rechner des Nutzers gespeichert und von diesem an unserer Seite übermittelt. Daher haben Sie
              als Nutzer auch die volle Kontrolle über die Verwendung von Cookies. Durch eine Änderung der
              Einstellungen in Ihrem Internetbrowser können Sie die Übertragung von Cookies deaktivieren
              oder einschränken. Bereits gespeicherte Cookies können jederzeit gelöscht werden. Dies kann
              auch automatisiert erfolgen. Werden Cookies für unsere Website deaktiviert, können
              möglicherweise nicht mehr alle Funktionen der Website vollumfänglich genutzt werden.</p>

            <p>2.1 Registrierung<br/>
              Auf unserer Internetseite bieten wir Nutzern die Möglichkeit, sich unter Angabe
              personenbezogener Daten zu registrieren. Die Daten werden dabei in eine Eingabemaske
              eingegeben und an uns übermittelt und gespeichert. Eine Weitergabe der Daten an Dritte
              findet nicht statt. Folgende Daten werden im Rahmen des Registrierungsprozesses
              erhoben:<br/>
              Im Zeitpunkt der Registrierung werden zudem folgende Daten gespeichert:</p>

            <p>&nbsp;&nbsp;&nbsp; • Die IP-Adresse des Nutzers<br/>
              &nbsp;&nbsp;&nbsp; • Datum und Uhrzeit der Registrierung</p>

            <p>Im Rahmen des Registrierungsprozesses wird eine Einwilligung des Nutzers zur Verarbeitung
              dieser Daten eingeholt. Eine Registrierung des Nutzers ist für das Bereithalten bestimmter
              Inhalte und Leistungen auf unserer Website erforderlich. Rechtsgrundlage für die
              Verarbeitung der Daten ist bei Vorliegen einer Einwilligung des Nutzers Art.&nbsp;6 Abs.&nbsp;1
              lit.&nbsp;a DSGVO.</p>

            <p>2.2 Kontaktformular<br/>
              Auf unserer Internetseite ist ein Kontaktformular vorhanden, welches für die elektronische
              Kontaktaufnahme genutzt werden kann. Nimmt ein Nutzer diese Möglichkeit wahr, so werden die
              in der Eingabemaske eingegeben Daten an uns übermittelt und gespeichert. Diese Daten
              sind:<br/>
              Im Zeitpunkt der Absendung der Nachricht werden zudem folgende Daten gespeichert:</p>

            <p>&nbsp;&nbsp;&nbsp; • Die IP-Adresse des Nutzers<br/>
              &nbsp;&nbsp;&nbsp; • Datum und Uhrzeit der Registrierung</p>

            <p>Für die Verarbeitung der Daten wird im Rahmen des Absende Vorgangs Ihre Einwilligung
              eingeholt und auf diese Datenschutzerklärung verwiesen. Alternativ ist eine Kontaktaufnahme
              über die bereitgestellte E-Mail-Adresse möglich. In diesem Fall werden die mit der E-Mail
              übermittelten personenbezogenen Daten des Nutzers gespeichert. Es erfolgt in diesem
              Zusammenhang keine Weitergabe der Daten an Dritte. Die Daten werden ausschließlich für die
              Verarbeitung der Konversation verwendet. Die Verarbeitung der personenbezogenen Daten aus
              der Eingabemaske dient uns allein zur Bearbeitung der Kontaktaufnahme. Im Falle einer
              Kontaktaufnahme per E-Mail liegt hieran auch das erforderliche berechtigte Interesse an der
              Verarbeitung der Daten. Die sonstigen während des Absende Vorgangs verarbeiteten
              personenbezogenen Daten dienen dazu, einen Missbrauch des Kontaktformulars zu verhindern und
              die Sicherheit unserer informationstechnischen Systeme sicherzustellen. Rechtsgrundlage für
              die Verarbeitung der Daten ist bei Vorliegen einer Einwilligung des Nutzers Art.&nbsp;6 Abs.&nbsp;1
              lit.&nbsp;a DSGVO. Rechtsgrundlage für die Verarbeitung der Daten, die im Zuge einer
              Übersendung einer E-Mail übermittelt werden, ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO.
              Zielt der E-Mail-Kontakt auf den Abschluss eines Vertrages ab, so ist zusätzliche
              Rechtsgrundlage für die Verarbeitung Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO. Die Daten
              werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr
              erforderlich sind. Für die personenbezogenen Daten aus der Eingabemaske des Kontaktformulars
              und diejenigen, die per E-Mail übersandt wurden, ist dies dann der Fall, wenn die jeweilige
              Konversation mit dem Nutzer beendet ist. Beendet ist die Konversation dann, wenn sich aus
              den Umständen entnehmen lässt, dass der betroffene Sachverhalt abschließend geklärt ist. Der
              Nutzer hat jederzeit die Möglichkeit, seine Einwilligung zur Verarbeitung der
              personenbezogenen Daten mit Wirkung für die Zukunft zu widerrufen. Nimmt der Nutzer per
              E-Mail Kontakt mit uns auf, so kann er der Speicherung seiner personenbezogenen Daten
              jederzeit widersprechen. In einem solchen Fall kann die Konversation nicht fortgeführt
              werden. Alle personenbezogenen Daten, die im Zuge der Kontaktaufnahme gespeichert wurden,
              werden in diesem Fall gelöscht.</p>

            <p>2.3 Tracking Tools<br/>
              Auf unserer Webseite verwenden wir Google Analytics als Tracking- und
              Webseitenanalysewerkzeug. Zweck ist die Effizienzsteigerung unserer Webseite und des
              Direktmarketings. In unserer App verwenden wir Matomo als Tracking- und Analysewerkzeug.
              Zweck ist die Effizienzsteigerung der App sowie die Darstellung des Warenbestands. Diese
              Tools werden von Drittanbietern betrieben und erfordern die Weitergabe von Daten über die
              Webseitenbesucher und App User. Rechtsgrundlage für den Einsatz der Webseitenanalyse ist
              Art. 6 Abs. 1 lit. f DSGVO.</p>

            <p>2.4 Social Media Plugins<br/>
              Auf unserer Webseite verwenden wir folgende Social-Media-Plugins:</p>

            <p>&nbsp;&nbsp;&nbsp; • LinkedIn<br/>
              &nbsp;&nbsp;&nbsp; • XING</p>

            <p>Die grundsätzliche Bereitstellung der Plugins auf unserer Webseite ergibt sich aus unserem
              berechtigten Interesse für Marketingzwecke aus Art. 6 Abs. 1 lit. f DSGVO.</p>

            <p>3. Rechtsgrundlage für die Verarbeitung personenbezogener Daten<br/>
              Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der
              betroffenen Person einholen, dient Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;a
              EU-Datenschutzgrundverordnung (DSGVO) als Rechtsgrundlage für die Verarbeitung
              personenbezogener Daten. Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung
              eines Vertrages, dessen Vertragspartei die betroffene Person ist, erforderlich ist, dient
              Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO als Rechtsgrundlage. Dies gilt auch für
              Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen erforderlich sind.
              Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen
              Verpflichtung erforderlich ist, der unser Unternehmen unterliegt, dient Art.&nbsp;6 Abs.&nbsp;1
              lit.&nbsp;c DSGVO als Rechtsgrundlage. Für den Fall, dass lebenswichtige Interessen der
              betroffenen Person oder einer anderen natürlichen Person eine Verarbeitung personenbezogener
              Daten erforderlich machen, dient Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;d DSGVO als
              Rechtsgrundlage.<br/>
              Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens oder
              eines Dritten erforderlich und überwiegen die Interessen, Grundrechte und Grundfreiheiten
              des Betroffenen das erstgenannte Interesse nicht, so dient Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f
              DSGVO als Rechtsgrundlage für die Verarbeitung. In diesem Fall sind unsere berechtigten
              Interessen neben den oben aufgeführten Zwecken:</p>

            <p>&nbsp;&nbsp;&nbsp; • Schutz des Unternehmens vor materiellen oder immateriellen Schäden<br/>
              &nbsp;&nbsp;&nbsp; • Die Professionalisierung unserer Produkte und Dienstleistungen<br/>
              &nbsp;&nbsp;&nbsp; • Kostenoptimierung.</p>

            <p>Weiterhin verarbeiten wir personenbezogene Daten, um handels- oder steuerrechtlichen
              Aufbewahrungspflichten nachzukommen. Für gesetzlich vorgeschriebene oder vertragliche
              Anforderungen haben wir in den Eingabemasken auf unserer Webseite die jeweiligen
              Eingabefelder gekennzeichnet, die von Ihnen zwingend auszufüllen sind, damit wir den von
              Ihnen gewünschten Service erbringen können.</p>

            <p>4. Datenlöschung und Speicherdauer<br/>
              Die personenbezogenen Daten der betroffenen Person werden gelöscht oder gesperrt, sobald der
              Zweck der Speicherung entfällt oder nicht mehr erforderlich ist. Dabei kann es vorkommen,
              dass personenbezogene Daten für die Zeit aufbewahrt werden, in der Ansprüche gegen unser
              Unternehmen geltend gemacht werden können (gesetzliche Verjährungsfristen können von drei
              bis zu dreißig Jahren vorliegen). Eine Speicherung kann darüber hinaus dann erfolgen, wenn
              dies durch den europäischen oder nationalen Gesetzgeber in unionsrechtlichen Verordnungen,
              Gesetzen oder sonstigen Vorschriften, denen der Verantwortliche unterliegt, vorgesehen
              wurde. Entsprechende Nachweis- und Aufbewahrungspflichten ergeben sich unter anderem aus dem
              Handelsgesetzbuch, der Abgabenordnung und dem Geldwäschegesetz. Die Speicherfristen betragen
              danach bis zu zehn Jahren. Eine Sperrung oder Löschung der Daten erfolgt auch dann, wenn
              eine durch die genannten Normen vorgeschriebene Speicherfrist abläuft, es sei denn, dass
              eine Erforderlichkeit zur weiteren Speicherung der Daten für einen Vertragsabschluss oder
              eine Vertragserfüllung besteht.</p>

            <p>5. Widerspruchsrecht nach Art. 21 DSGVO<br/>
              Sie haben das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben, jederzeit
              gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten, die aufgrund von Art.&nbsp;6
              Abs.&nbsp;1 lit.&nbsp;e oder f DSGVO erfolgt, Widerspruch einzulegen; dies gilt auch für ein
              auf diese Bestimmungen gestütztes Profiling.</p>

            <p>Der Verantwortliche verarbeitet die Sie betreffenden personenbezogenen Daten nicht mehr, es
              sei denn, er kann zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre
              Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der
              Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen. Werden die Sie betreffenden
              personenbezogenen Daten verarbeitet, um Direktwerbung zu betreiben, haben Sie das Recht,
              jederzeit Widerspruch gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten
              zum Zwecke derartiger Werbung einzulegen; dies gilt auch für das Profiling, soweit es mit
              solcher Direktwerbung in Verbindung steht. Widersprechen Sie der Verarbeitung für Zwecke der
              Direktwerbung, so werden die Sie betreffenden personenbezogenen Daten nicht mehr für diese
              Zwecke verarbeitet. Sie haben die Möglichkeit, im Zusammenhang mit der Nutzung von Diensten
              der Informationsgesellschaft – ungeachtet der Richtlinie 2002/58/EG – Ihr Widerspruchsrecht
              mittels automatisierter Verfahren auszuüben, bei denen technische Spezifikationen verwendet
              werden.</p>

            <p>6. Rechte der betroffenen Person<br/>
              Für unser Unternehmen ist es ein wichtiges Anliegen, unsere Prozesse zur Verarbeitung
              personenbezogener Daten transparent zu gestalten. Daher weisen wir darauf hin, dass Sie
              neben dem Widerspruchsrecht weitere Rechte bei Vorliegen der jeweiligen gesetzlichen
              Voraussetzungen ausüben können:</p>

            <p>&nbsp;&nbsp;&nbsp; • Recht auf Auskunft nach Art. 15 DSGVO<br/>
              &nbsp;&nbsp;&nbsp; • Recht auf Berichtigung nach Art. 16 DSGVO<br/>
              &nbsp;&nbsp;&nbsp; • Recht auf Löschung („Recht auf Vergessen werden“) nach Art. 17
              DSGVO<br/>
              &nbsp;&nbsp;&nbsp; • Recht auf Einschränkung der Verarbeitung nach Art. 18 DSGVO<br/>
              &nbsp;&nbsp;&nbsp; • Recht auf Unterrichtung nach Art. 19 DSGVO<br/>
              &nbsp;&nbsp;&nbsp; • Recht auf Datenübertragbarkeit nach Art. 20 DSGVO<br/>
              &nbsp;&nbsp;&nbsp; • (keine) automatisierte Entscheidung im Einzelfall einschließlich
              Profiling nach Art. 21 DSGVO</p>

            <p>Um Ihre Rechte wahrzunehmen, können Sie sich per E-Mail an datenschutz@hensel-recycling.com
              wenden. Um Ihren Antrag bearbeiten zu können sowie zu Identifizierungszwecken, weisen wir
              darauf hin, dass wir Ihre personenbezogenen Daten nach Art. 6 Abs. 1 lit. c DSGVO
              verarbeiten.</p>

            <p>7. Einwilligung<br/>
              Sie haben das Recht, Ihre datenschutzrechtliche Einwilligungserklärung jederzeit mit Wirkung
              für die Zukunft zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit
              der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt. In
              einigen Fällen sind wir trotz des Widerrufs dazu berechtigt, Ihre personenbezogenen Daten
              auf einer anderen Rechtsgrundlage (zur Erfüllung eines Vertrages) weiter zu verarbeiten.</p>

            <p>8. Recht auf Beschwerde bei einer Aufsichtsbehörde<br/>
              Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs
              steht Ihnen das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem
              Mitgliedstaat ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen
              Verstoßes, zu, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden
              personenbezogenen Daten gegen die DSGVO verstößt. Die Aufsichtsbehörde, bei der die
              Beschwerde eingereicht wurde, unterrichtet den Beschwerdeführer über den Stand und die
              Ergebnisse der Beschwerde einschließlich der Möglichkeit eines gerichtlichen Rechtsbehelfs
              nach Art.&nbsp;78 DSGVO.</p>

            <p>Zuständige Aufsichtsbehörde:</p>

            <p>Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)<br/>
              Promenade 27<br/>
              91522 Ansbach</p>

          </div>
        </bulma-accordion-item>
        <bulma-accordion-item>
          <h4 slot="title" style="padding-right: .5em">CONDIZIONE D’USO PER LO SCARICO E L’UTILIZZO
            DELL’APPLICAZIONE DEL CATALOGO</h4>
          <div slot="conent">
            <h3>Dichiarazione</h3>

            <p>Acconsento che la ditta Hensel Recycling GmbH (qui di seguito HR) raccolga, elabori e usi
              informazioni relative al mio utilizzo di questa applicazione del catalogo. Queste
              informazioni includono il mio nome utente. La HR tratterà in modo confidenziale questi dati
              e non li cederà a terzi. Ciò non vale allorquando la HR sia tenuta alla trasmissione dei
              dati in forma legale o nell’ambito di un procedimento giudiziario.<br/>
              &nbsp;Sono a conoscenza del fatto che la HR potrà usare i dati raccolti allo scopo di:</p>

            <p>- contrastare l’uso improprio del catalogo, in particolare&nbsp;la persecuzione del furto di
              dati o la trasmissione impropria dei dati di accesso (nome utente e parola d’ordine)<br/>
              - migliorare il contatto del cliente, in particolare tramite la registrazione di tipo e
              numero di modelli di catalizzatori<br/>
              - migliorare l’utilizzo dell’applicazione</p>

            <p>Posso revocare il presente consenso in qualsiasi momento in forma scritta e in relazione a un
              uso futuro. Posso richiedere la cancellazione o il blocco dei dati già acquisiti nella
              misura in cui essi non siano necessari nell’ambito della relazione commerciale corrente e
              non comportino un onere eccessivo per la HR.</p>

            <h3>CONDIZIONE D’USO PER LO SCARICO E L’UTILIZZO DELL’APPLICAZIONE DEL CATALOGO</h3>

            <p>1.&nbsp; Introduzione<br/>
              I contenuti di questa applicazione sono stati consolidati da Hensel Recycling GmbH (qui di
              seguito HR) con la più grande cura. Tuttavia non possiamo assumerci la garanzia della
              completezza e correttezza dei dati. HR per tanto non assume alcuna responsabilità per errori
              nei contenuti. Tramite l’accesso vengono accettate senza limitazioni o riserve le seguenti
              condizioni di utilizzo:</p>

            <p>2. Diritti d’autore<br/>
              Le immagini e i contenuti sono nostra proprietà intellettuale e godono della protezione dei
              diritti d’autore questi non possono quindi né essere riprodotti, diffusi, manipolati,
              traslati, né essere salvati in altri. Media o elaborati, compresi quelli in formato
              elettronico. Ogni utilizzo dei contenuti necessita la preventiva autorizzazione di HR.
              L’utilizzo dell’applicazione del catalogo può essere revocato in qualsiasi momento e senza
              fornire giustificazioni da parte di HR.</p>

            <p>3. Responsabilità<br/>
              Le diverse informazioni messe a disposizione sono state consolidate al meglio della nostra
              conoscenza. Ciò tuttavia un costante aggiornamento dei dati non può essere garantito. Le
              richieste di risarcimento danni da parte del cliente a causa di informazioni errate sono
              quindi da escludersi. Offerte e conferme d’ordine effettuate sulla base di errate
              informazioni del cliente non sono più valide. Con l’accettazione delle condizioni di
              utilizzo, l’utente si dichiara totalmente d’accordo che per la definizione del valore finale
              è determinante la classificazione da parte dei nostri collaboratori. Per il saldo del valore
              dei catalizzatori sulla base di categorie fa fede la categorizzazione al momento del
              conferimento dell’ordine.</p>

            <h4>Dichiarazione di protezione dei dati secondo RGPD</h4>

            <p>1. Nome e indirizzo del titolare del trattamento<br/>
              Il titolare del trattamento ai sensi del Regolamento generale sulla protezione dei dati e di
              altre leggi nazionali sulla tutela dei dati vigenti nei Paesi membri dell’Unione Europea,
              nonché di altre disposizioni di carattere normativo in materia di protezione dei dati è la:
            </p>

            <p>Hensel Recycling GmbH<br/>
              Mühlweg 10<br/>
              D-63743 Aschaffenburg<br/>
              Germania<br/>
              Tel.: +49 6028 1209-0<br/>
              Email: info@hensel-recycling.com<br/>
              Sito web: <a href="http://www.hensel-recycling.com">www.hensel-recycling.com</a></p>

            <p>Noi Vi informiamo qui di seguito sul trattamento dei Vostri dati personali nell’ambito
              dell’utilizzo del nostro sito web. Qualora aveste ulteriori domande sulla tutela di dati in
              rapporto al nostro sito web o ai servizi da noi offerti, Vi preghiamo di voler contattare il
              nostro incaricato della protezione dei dati.<br/>
              L’incaricato della protezione dei dati del titolare del trattamento è:</p>

            <p>Rudolf Fiedler<br/>
              DPP Data Protection GmbH<br/>
              Email: datenschutz@hensel-recycling.com</p>

            <p>2. Ambito, finalità e fondamento giuridico del trattamento di dati personali<br/>
              Noi raccogliamo e utilizziamo dati personali dei nostri utenti fondamentalmente, solo nella
              misura in cui ciò sia necessario per la messa a disposizione di un sito web funzionante,
              come pure dei nostri contenuti e servizi. La raccolta e l’utilizzo dei dati personali dei
              nostri utenti avviene di norma solo previo consenso dell’utente. Un’eccezione in tali casi è
              data, quando una preventiva richiesta di un consenso non è possibile per motivi oggettivi e
              l’elaborazione dei dati è ammessa dalle norme di legge.</p>

            <p>2.1 Creazione di log file<br/>
              Ad ogni visualizzazione della nostra pagina Internet, il nostro sistema rileva
              automaticamente dati e informazioni dal sistema del computer che effettua l’accesso.<br/>
              Vengono con ciò raccolti i seguenti dati („Informazioni tecniche“):</p>

            <p>&nbsp;&nbsp;&nbsp; • informazioni sul tipo di browser e sulla versione usata<br/>
              &nbsp;&nbsp;&nbsp; • il sistema operativo dell’utente<br/>
              &nbsp;&nbsp;&nbsp; • l’Internet provider dell’utente<br/>
              &nbsp;&nbsp;&nbsp; • l’indirizzo IP dell’utente in forma anonimizzata<br/>
              &nbsp;&nbsp;&nbsp; • data e ora dell’accesso<br/>
              &nbsp;&nbsp;&nbsp; • siti web, da cui il sistema dell’utente è giunto alla nostra pagina
              Internet<br/>
              &nbsp;&nbsp;&nbsp; • siti web, a cui si ha accesso dal sistema dell’utente tramite il nostro
              sito web</p>

            <p>I dati vengono anche memorizzati nei log file del nostro sistema. Ciò non riguarda gli
              indirizzi IP dell’utente o altri dati, che consentono l’associazione dei dati ad un utente.
              Una memorizzazione di questi dati insieme con altri dati personali dell’utente non ha luogo.
              Noi trattiamo queste informazioni tecniche ai fini della sicurezza in rete, per poter
              contrastare ad es. attacchi informatici, con finalità di marketing, per poter meglio
              comprendere le esigenze dei nostri utenti e per migliorare la nostra offerta sulle nostre
              pagine web. In tali scopi rientra anche il nostro legittimo interesse al trattamento dei
              dati secondo l’Art. 6 comma 1 lettera f) del RGPD. La raccolta di dati per la messa a
              disposizione del sito web e l’archiviazione di dati in log file è assolutamente necessaria
              per la funzionalità della pagina Internet. Non sussiste di conseguenza alcuna possibilità di
              opporsi da parte dell’utente</p>

            <p>2.2 Utilizzo di cookie<br/>
              Il nostro sito web utilizza cookie. I cookie sono file di testo che vengono memorizzati nel
              browser Internet o nel browser Internet sul sistema del computer dell’utente. Quando un
              utente visualizza un sito web, un cookie può essere memorizzato sul sistema operativo
              dell’utente. Questo cookie contiene una sequenza di segni caratteristici, che permettono una
              chiara e univoca identificazione del browser al rinnovato accesso al sito web. Noi
              utilizziamo cookie per configurare in modo ancora più user-friendly il nostro sito web.
              Alcuni elementi della nostra pagina Internet richiedono che il browser che effettua l’acceso
              possa essere identificato anche dopo un cambio di pagina. Inoltre utilizziamo sul nostro
              sito web cookie, che consentono un’analisi del comportamento di navigazione dell’utente. I
              dati dell’utente raccolti in questo modo vengono sottoposti, tramite misure
              tecnico-preventive, a pseudonimizzazione. Non è, pertanto, possibile un’associazione dei
              dati all’utente operante l’accesso. I dati non vengono memorizzati insieme con altri dati
              personali dell’utente. Con l’accesso al nostro sito web, gli utenti vengono informati da
              banner informativi dell’utilizzo di cookie a fini analitici e rimandati a questa
              dichiarazione di protezione dei dati. Con l’accesso al nostro sito web, l’utente viene
              informato dell’utilizzo di cookie a fini analitici e viene richiesto il suo consenso per il
              trattamento dei dati personali utilizzati in tale contesto. In rapporto a ciò si rimanda
              anche a questa dichiarazione di protezione di dati. La finalità dell’utilizzo di cookie
              necessari a livello tecnico è facilitare all’utente l’uso del sito web. Alcune funzioni del
              nostro sito Internet non possono essere offerte senza l’impiego di cookie. La nostra pagina
              Internet richiede che il browser possa essere riconosciuto anche dopo un cambio di pagina. I
              dati dell’utente rilevati tramite cookie necessari a livello tecnico non vengono utilizzati
              per la creazione di profili di utenti. L’utilizzo di cookie analitici avviene allo scopo di
              migliorare la qualità del nostro sito web e dei suoi contenuti. Con i cookie analitici
              possiamo sapere come viene utilizzato il sito web e, quindi, ottimizzare continuamente la
              nostra offerta. In tali scopi rientra anche il nostro legittimo interesse al trattamento dei
              dati personali e anche il suo fondamento giuridico secondo l’Art. 6 comma 1 lettera f) del
              RGPD. I cookie vengono memorizzati sul computer dell’utente e, da questo, trasmessi alla
              nostra pagina. Pertanto, come utenti avete anche il completo controllo per quanto riguarda
              l’utilizzo di cookie. Modificando le impostazioni del Vostro browser Internet potete
              disattivare o limitare la trasmissione di cookie. Cookie che sono stati memorizzati possono
              essere in ogni momento cancellati. Ciò può avvenire anche in modo automatizzato. Se vengono
              disattivati cookie per il nostro sito web, può accadere che non sia più possibile
              utilizzarne integralmente tutte le funzioni.</p>

            <p>2.1 Registrazione<br/>
              Sulla nostra pagina Internet offriamo agli utenti la possibilità di registrarsi, indicando i
              propri dati personali. I dati vengono a tal fine inseriti in una maschera d’immissione e ci
              vengono trasmessi per la memorizzazione. Non ha luogo un inoltro dei dati a terzi. Nel
              quadro della procedura di registrazione vengono raccolti i seguenti dati:<br/>
              Al momento della registrazione vengono memorizzati inoltre i seguenti dati:</p>

            <p>&nbsp;&nbsp;&nbsp; • l’indirizzo IP dell’utente<br/>
              &nbsp;&nbsp;&nbsp; • data e ora della registrazione</p>

            <p>Nel quadro della procedura di registrazione viene richiesto un consenso dell’utente al
              trattamento di tali dati. Una registrazione dell’utente è necessaria per la messa a
              disposizione di determinati contenuti e servizi sul nostro sito web. Fondamento giuridico
              per il trattamento dei dati in presenza di un consenso dell’utente è l’Art. 6 comma 1
              lettera a) del RGPD.</p>

            <p>2.2 Modulo di contatto<br/>
              Sulla nostra pagina Internet è disponibile un modulo di contatto, che può essere utilizzato
              per la presa di contatto elettronica. Se l’utente fa uso di questa possibilità, i dati
              vengono inseriti nella maschera d’immissione e ci vengono trasmessi per la memorizzazione.
              Questi dati sono:<br/>
              Al momento dell’invio del messaggio vengono memorizzati inoltre i seguenti dati:</p>

            <p>&nbsp;&nbsp;&nbsp; • l’indirizzo IP dell’utente<br/>
              &nbsp;&nbsp;&nbsp; • data e ora della registrazione</p>

            <p>Per il trattamento di dati, nel quadro della procedura d’invio, viene richiesto il Vostro
              consenso e venite rimandati a questa dichiarazione di protezione dei dati. In alternativa, è
              possibile una presa di contatto tramite l’indirizzo email messo a disposizione. In questo
              caso i dati personali trasmessi con l’email vengono memorizzati insieme con altri dati
              personali dell’utente. Non ha luogo in tale contesto alcun inoltro dei dati a terzi. I dati
              vengono utilizzati esclusivamente per l’elaborazione della comunicazione. Il trattamento di
              dati personali ottenuti da una maschera d’immissione è finalizzato alla sola elaborazione da
              parte nostra della presa di contatto. Nel caso di una presa di contatto tramite email, anche
              in questo caso si è in presenza del richiesto legittimo interesse al trattamento dei dati.
              Gli altri dati personali elaborati durante la procedura d’invio servono a impedire un uso
              improprio del modulo di contatto e a garantire la sicurezza dei nostri sistemi informatici.
              Fondamento giuridico per il trattamento dei dati in presenza di un consenso dell’utente è
              l’Art. 6 comma 1 lettera a) del RGPD. Fondamento giuridico per il trattamento dei dati, che
              vengono trasmessi in occasione dell’invio di una email, è l’Art. 6 comma&nbsp; 1 lettera f)
              del RGPD. Se il contatto via email ha come finalità la conclusione di un contratto,
              l’ulteriore fondamento giuridico per il trattamento dei dati è l’Art. 6 comma 1 lettera b)
              del RGPD. I dati verranno cancellati non appena questi non siano più necessari al
              conseguimento della finalità per cui sono stati raccolti. Un tal caso si verifica per i dati
              personali ottenuti dalla maschera d’immissione del modulo di contatto e per quelli che sono
              stati inviati tramite email, quando la rispettiva comunicazione con l’utente è terminata. La
              comunicazione è terminata quando le circostanze lasciano presumere che la questione in
              oggetto è stata definitivamente chiarita. L’utente ha in ogni momento la possibilità di
              revocare il proprio consenso al trattamento dei dati personali con effetto per il futuro. Se
              l’utente prende contatto con noi tramite email, egli può in ogni momento opporsi alla
              memorizzazione e conservazione di propri dati personali. In tal caso la comunicazione non
              può essere proseguita. Tutti i dati personali, che sono stati memorizzati in occasione della
              presa di contatto, vengono in questo caso cancellati.</p>

            <p>2.3 Strumenti di tracciamento<br/>
              Sul nostro sito web utilizziamo Google Analytics come strumento di tracciamento e analisi
              delle pagine web. Obiettivo è aumentare l’efficienza del nostro sito web e il marketing
              diretto. Sulla nostra App utilizziamo Matomo come strumento di tracciamento e analisi.
              Obiettivo è aumentare l’efficienza della nostra App, così come la rappresentazione di quanto
              è contenuto nel carrello. Questi strumenti vengono gestiti da parti terze e richiedono
              l’inoltro di dati dei visitatori del sito web e dell’App. Fondamento giuridico per
              l’utilizzo dell’analisi di pagine web è l’Art. 6 comma 1 lettera f) del RGPD.</p>

            <p>2.4 Plugin per social media<br/>
              Sul nostro sito utilizziamo i seguenti plugin per social media:</p>

            <p>&nbsp;&nbsp;&nbsp; • LinkedIn<br/>
              &nbsp;&nbsp;&nbsp; • XING</p>

            <p>La basilare messa a disposizione dei plugin sul nostro sito web si deve al nostro legittimo
              interesse con finalità di marketing, che trova fondamento nell’Art. 6 comma 1 lettera f) del
              RGPD.</p>

            <p>3. Fondamento giuridico per il trattamento di dati personali<br/>
              Nella misura in cui richiediamo per le procedure di trattamento dei dati personali un
              consenso della persona interessata, funge da fondamento giuridico per il trattamento dei
              dati personali l’Art. 6 comma 1 lettera a) del Regolamento UE generale sulla protezione dei
              dati (RGPD). Per il trattamento di dati personali, che è necessario per l’esecuzione di un
              contratto, di cui la persona interessata è parte, funge da fondamento giuridico l’Art. 6
              comma 1 lettera b) del RGPD. Ciò vale anche per procedure di trattamento, che sono
              necessarie per l’attuazione di misure precontrattuali. Nella misura in cui un trattamento di
              dati personali è necessario per l’adempimento di un obbligo giuridico a cui è soggetta la
              nostra impresa, funge da fondamento giuridico l’Art. 6 comma 1 lettera c) del RGPD. Per il
              caso in cui un trattamento di dati personali sia reso necessario per la salvaguardia degli
              interessi vitali della persona interessata o di un’altra persona fisica, funge da fondamento
              giuridico l’Art. 6 comma 1 lettera d) del RGPD.<br/>
              Se il trattamento è necessario per la tutela di un legittimo interesse della nostra impresa
              o di un terzo e non prevalgono su questo gli interessi o i diritti e le libertà fondamentali
              dell’interessato, funge da fondamento giuridico per il trattamento l’Art. 6 comma 1 lettera
              f ) del RGPD. In questo caso i nostri legittimi interessi sono oltre alle suddette finalità:
            </p>

            <p>&nbsp;&nbsp;&nbsp; • la tutela dell’impresa da danni materiali e immateriali<br/>
              &nbsp;&nbsp;&nbsp; • la professionalità dei nostri prodotti e servizi<br/>
              &nbsp;&nbsp;&nbsp; • l’ottimizzazione dei costi.</p>

            <p>Inoltre elaboriamo i dati personali per assolvere agli obblighi di conservazione della
              documentazione commerciale e fiscale. Per esigenze di conformità contrattuale o normativa
              abbiamo contrassegnato nelle maschere d’immissione sul nostro sito web i rispettivi campi
              d’inserimento, che debbono obbligatoriamente essere compilati, affinché si possa da parte
              nostra fornirvi il servizio desiderato.</p>

            <p>4. Cancellazione dei dati e durata di conservazione<br/>
              I dati personali della persona interessata vengono cancellati o bloccati, non appena venga
              meno la finalità della loro conservazione o quest’ultima non sia più necessaria. Può
              accadere in proposito che i dati personali vengano custoditi per il tempo in cui possano
              essere fatti valere diritti nei confronti della nostra impresa (i termini prescrizionali di
              legge possono estendersi da tre sino a trent’anni). Un’archiviazione e conservazione può poi
              avvenire, nella misura in cui ciò sia stato previsto dal legislatore nazionale o europeo in
              decreti legislativi, leggi o altre direttive in materia del diritto dell’unione, a cui è
              soggetto il titolare del trattamento dei dati. Obblighi di conservazione e documentazione in
              tal senso risultano fra l’altro dal codice commerciale tedesco, dal codice tributario e
              dalla legge sul riciclaggio di denaro. Questi prevedono una durata di conservazione di sino
              a dieci anni. Un blocco o una cancellazione di dati ha luogo poi, se scade il termine di
              archiviazione prescritto dalle suddette norme, a meno che non sussista una necessità di
              ulteriore archiviazione dei dati per una stipula o un adempimento di contratto.</p>

            <p>5. Diritto di opposizione secondo Art. 21 del RGPD<br/>
              Voi avete il diritto di opporvi, in qualsiasi momento, per motivi connessi alla Vostra
              particolare situazione, al trattamento dei dati personali che Vi riguardano ai sensi
              dell’Art. 6 comma 1 lettera e) o f) del RGPD, compresa la profilazione sulla base di queste
              disposizioni. Il titolare del trattamento si astiene dal trattare ulteriormente i dati
              personali, salvo che egli dimostri l’esistenza di motivi legittimi cogenti per procedere al
              trattamento, che prevalgono sui Vostri interessi, sui Vostri diritti e sulle Vostre libertà,
              o il trattamento serva per l’affermazione, l’esercizio o la difesa di un diritto in sede
              giudiziaria. Qualora i dati personali che Vi riguardano siano trattati per finalità di
              marketing diretto, avete il diritto di opporvi in qualsiasi momento al trattamento dei dati
              personali che Vi riguardano effettuato per tali finalità, compresa la profilazione nella
              misura in cui sia connessa a tale marketing diretto. Se Vi opponete al trattamento per
              finalità di marketing diretto, i dati personali che Vi riguardano non saranno più oggetto di
              trattamento per tali finalità. Nel contesto dell’utilizzo di servizi della società
              dell’informazione – fatta salva la direttiva 2002/58/CE – avete la possibilità di esercitare
              il Vostro diritto di opposizione con mezzi automatizzati che utilizzano specifiche tecniche.
            </p>

            <p>6. Diritti della persona interessata<br/>
              Per la nostra impresa è una questione di prioritaria importanza gestire con trasparenza i
              nostri processi di trattamento dei dati personali. Pertanto Vi segnaliamo che, oltre al
              diritto di opposizione potete, in presenza dei rispettivi presupposti di legge, esercitare
              altri diritti:</p>

            <p>&nbsp;&nbsp;&nbsp; • diritto di accesso a informazioni secondo Art. 15 del RGPD<br/>
              &nbsp;&nbsp;&nbsp; • diritto di rettifica secondo Art. 16 del RGPD<br/>
              &nbsp;&nbsp;&nbsp; • diritto alla cancellazione („diritto all’oblio“) secondo Art. 17 del
              RGPD<br/>
              &nbsp;&nbsp;&nbsp; • diritto di limitazione del trattamento secondo Art. 18 del RGPD<br/>
              &nbsp;&nbsp;&nbsp; • diritto alla notifica secondo Art. 19 del RGPD<br/>
              &nbsp;&nbsp;&nbsp; • diritto alla portabilità dei dati secondo Art. 20 del RGPD<br/>
              &nbsp;&nbsp;&nbsp; •&nbsp; (nessun) processo decisionale automatizzato nel singolo caso,
              compresa profilazione secondo Art. 21 del RGPD</p>

            <p>Per conoscere i Vostri diritti, potete rivolgervi via email a
              datenschutz@hensel-recycling.com. Siamo a segnalarvi che per elaborare la Vostra richiesta e
              a fini identificativi, rileveremo e raccoglieremo i Vostri dati personali conformemente a
              quanto indicato all’Art. 6 comma 1 lettera c) del RGPD</p>

            <p>7. Consenso<br/>
              Voi avete il diritto di revocare in ogni momento la Vostra dichiarazione di consenso in
              riferimento alla tutela dei dati con effetto per il futuro. La revoca del consenso non
              pregiudica la liceità del trattamento avvenuto sulla base del consenso sino alla revoca di
              questo. In alcuni casi, nonostante la revoca, siamo autorizzati, sulla base di un altro
              fondamento giuridico (al fine dell’adempimento del contratto), a continuare il trattamento
              dei Vostri dati personali.</p>

            <p>8. Diritto di proporre reclamo all’autorità di controllo<br/>
              Fatto salvo ogni altro ricorso amministrativo o giurisdizionale, avete il diritto di
              proporre reclamo a un’autorità di controllo, segnatamente nello Stato membro in cui
              risiedete abitualmente, lavorate oppure del luogo ove si è verificata la presunta
              violazione, qualora riteniate, che il trattamento dei dati personali che Vi riguardano violi
              il RGPD. L’autorità di controllo a cui è stato avanzato il reclamo informa il reclamante
              dello stato o dell’esito del reclamo, compresa la possibilità di un ricorso giurisdizionale
              ai sensi dell’Art. 78 del RGPD.<br/>
              Competente autorità di controllo:</p>

            <p>Ufficio Regionale della Baviera per il Controllo della Protezione di Dati (BayLDA)<br/>
              Promenade 27<br/>
              D-91522 Ansbach</p>

          </div>
        </bulma-accordion-item>
        <bulma-accordion-item>
          <h4 slot="title" style="padding-right: .5em">Conditions générales d'utilisation pour le
            téléchargement et l'utilisation de l'application catalogue</h4>
          <div slot="content">
            <h3>Consentement de l’utilisateur sur la confidentialité juridique de la collecte de
              données.</h3>

            <p>J’accepte que Hensel Recycling GmbH (ci-après&nbsp;: HR) collecte, traite et utilise les
              informations renseignées dans cette application. Ces informations concernent également mon
              identifiant. HR s’engage à traiter ces informations de façon confidentielle et à ne pas les
              communiquer à des tiers, sauf si HR est contrainte de le faire légalement ou dans le cadre
              de procédures judiciaires.<br/>
              Je reconnais que HR utilisera les données saisies pour&nbsp;:</p>

            <p>&nbsp;&nbsp;&nbsp; • Combattre les utilisations frauduleuses, en particulier la poursuite
              judiciaire suite à des vols de données ou de communication non autorisée des données de
              connexion (identifiant et mot de passe)<br/>
              &nbsp;&nbsp;&nbsp; • L’enrichissement des données de contacts clients, en particulier via la
              saisie de la nature et quantités des types de pots catalytiques concernés<br/>
              &nbsp;&nbsp;&nbsp; • L’amélioration de l’application</p>

            <p>Je peux révoquer ce consentement à tout moment par écrit avec prise d’effet non rétroactive.
              Je peux exiger la suppression ou le blocage des données déjà transmises, sous réserve que
              ces données ne soient pas nécessaires dans le cadre des relations commerciales en cours et
              que cela ne représente pas une charge de travail disproportionnée pour HR.<br/>
              Conformément à la loi « informatique et libertés » du 6 janvier 1978 modifiée en 2004, j’ai
              pris note que je bénéficie d’un droit d’accès et de rectification aux informations qui me
              concernent, que je peux exercer en m’adressant à&nbsp;: Service Commercial, Hensel Recycling
              France, 10 rue Plucharde, 21110 BRETENIERE.<br/>
              Je peux également, pour des motifs légitimes, m’opposer au traitement des données me
              concernant.</p>

            <h4>Conditions générales d'utilisation pour le téléchargement et l'utilisation de l'application
              catalogue</h4>

            <p>1. Introduction<br/>
              Les contenus de cette application ont été mis en œuvre par la société Hensel Recycling GmbH
              (ci-après nommée HR) avec la plus grande attention. Nous ne pouvons cependant pas garantir
              que les données soient complètes et exactes. HR ne peut être tenue responsable pour les
              éventuelles erreurs contenues dans cette application. Le fait d'accéder à cette application
              suppose une acceptation sans restriction ni réserve des présentes conditions d'utilisation.
            </p>

            <p>2. Droits de propriété<br/>
              De nombreux contenus et illustrations sont la propriété intellectuelle de HR et soumis à un
              droit de propriété. Ces informations ne peuvent donc être copiées, diffusées, transformées,
              traduites, sauvegardées ou traitées sur quelque support que ce soit, y compris électronique.
              Toute utilisation du contenu nécessité un accord écrit préalable de la part de HR
              L'utilisation de l'application catalogue peut être retirée par HR à n'importe quel moment et
              sans justification.</p>

            <p>3. Responsabilité<br/>
              Les informations mises à disposition l'ont été sur la base de nos connaissances en toute
              bonne foi. Une actualisation permanente des données ne peut être garantie. Toute demande
              d’indemnisation de la part de l'utilisateur en raison de données erronées est donc exclue.
              Les offres de prix et confirmations de commandes effectuées sur la base de données client
              erronées perdent toute validité. L'acceptation des conditions d'utilisation suppose que
              l'utilisateur donne son accord préalable sur le fait que seules les valorisations effectuées
              par nos collaborateurs sont contractuelles. Les offres commerciales qui résulteront d’un tri
              à la catégorie seront valorisées au cours du jour du tri concerné.</p>

            <h3>Déclaration de confidentialité selon le RGPD</h3>

            <p>1. Nom et adresse du responsable<br/>
              Le responsable aux termes du règlement général sur la protection des données, d’autres lois
              nationales sur la protection des données et d’autres dispositions régissant la protection
              des données est la société</p>

            <p>Hensel Recycling GmbH<br/>
              Mühlweg 10<br/>
              D-63743 Aschaffenburg<br/>
              Allemagne<br/>
              Tél. : +49 6028 1209-0<br/>
              E-mail : info@hensel-recycling.com<br/>
              Site Internet : www.hensel-recycling.com</p>

            <p>Nous vous informons ci-après du traitement de vos données personnelles dans le cadre de
              l’utilisation de notre site Internet. Si vous avez d’autres questions concernant la
              protection des données, liées à notre site Internet ou aux services proposés, veuillez
              contacter notre chargé de la protection des données.<br/>
              Le chargé de la protection des données chez le responsable est :</p>

            <p>Rudolf Fiedler<br/>
              DPP Data Protection GmbH<br/>
              E-mail : datenschutz@hensel-recycling.com</p>

            <p>2. Étendue, objectif et base juridique du traitement des données personnelles<br/>
              Nous prélevons et utilisons les données personnelles de nos utilisateurs uniquement dans la
              mesure où cela s’avère nécessaire pour la mise à disposition d’un site Internet opérationnel
              et pour proposer nos contenus et prestations de service. Le prélèvement et l’utilisation des
              données personnelles de nos utilisateurs s’effectuent régulièrement uniquement après accord
              de l’utilisateur. Les cas, dans lesquels il est impossible de se procurer l’autorisation au
              préalable pour des raisons de fait, forment une exception si le traitement des données est
              autorisé par des prescriptions légales.</p>

            <p>2.1 Création de fichiers journaux<br/>
              Lors de chaque visite de notre site Internet, notre système saisit automatiquement des
              données et informations du système informatique de l’ordinateur accédant à notre site.<br/>
              Les données suivantes (« informations techniques ») sont ainsi prélevées :</p>

            <p>&nbsp;&nbsp;&nbsp; • Des informations sur le type de navigateur et la version utilisée<br/>
              &nbsp;&nbsp;&nbsp; • Le système d’exploitation de l’utilisateur<br/>
              &nbsp;&nbsp;&nbsp; • Le fournisseur de service Internet de l’utilisateur<br/>
              &nbsp;&nbsp;&nbsp; • L’adresse IP de l’utilisateur sous forme anonymisée<br/>
              &nbsp;&nbsp;&nbsp; • La date et l’heure de l’accès au site Internet<br/>
              &nbsp;&nbsp;&nbsp; • Les sites Internet à partir desquels l’utilisateur accède à notre site
              Internet<br/>
              &nbsp;&nbsp;&nbsp; • Les sites Internet que l’utilisateur appelle via notre site Internet
            </p>

            <p>Les données sont également mémorisées dans les fichiers journaux de notre système. Ne sont
              pas ici concernées les adresses IP de l’utilisateur ou d’autres données, qui permettent
              d’associer les données à un utilisateur. Nous ne mémorisons pas ces données avec les autres
              données personnelles de l’utilisateur. Nous traitons ici ces informations techniques pour
              sécuriser le réseau, par exemple pour pouvoir lutter contre des attaques, à des fins
              marketing, pour mieux pouvoir comprendre les exigences de nos utilisateurs et pour améliorer
              l’offre sur notre site Internet. Ces objectifs justifient également nos intérêts légitimes
              en matière de traitement de données aux termes de l’article 6 alinéa 1 lettre f RGPD. La
              saisie des données pour la mise à disposition du site Internet et la mémorisation des
              données dans des fichiers journaux sont absolument indispensables pour le bon fonctionnement
              du site Internet. L’utilisateur n’a donc pas la possibilité de s’y opposer.</p>

            <p>2.2 Utilisation de cookies<br/>
              Notre site Internet utilise des cookies. Les cookies sont des fichiers textes mémorisés sur
              le navigateur Internet, resp. que le navigateur Internet mémorise sur le système
              informatique de l’utilisateur. Lorsque l’utilisateur accède à un site Internet, un cookie
              peut être mémorisé sur le système d’exploitation de l’utilisateur. Ce cookie contient une
              chaîne de caractères caractéristique, qui permet une identification claire du navigateur
              lors de nouvelles visites du site Internet. Nous utilisons des cookies pour faciliter
              l’utilisation de notre site Internet. Quelques éléments de notre site Internet nécessitent
              que le navigateur, accédant à notre site, puisse encore être identifié après un changement
              de site. Sur notre site Internet, nous utilisons en outre des cookies, qui permettent
              d’analyser les habitudes de navigation de l’utilisateur. Les données ainsi prélevées sont
              pseudomysées par des mesures techniques. Il n’est donc plus possible de relier les données à
              l’utilisateur navigant sur notre site Internet. Ces données ne sont pas mémorisées
              conjointement avec les autres données personnelles de l’utilisateur. Lors de la visite de
              notre site Internet, les utilisateurs sont informés de l’utilisation de cookies à des fins
              d’analyse par une bannière d’information et renvoyés à la présente déclaration de
              confidentialité. En appelant notre site Internet, l’utilisateur est informé de l’utilisation
              de cookies à des fins d’analyse et nous lui demandons son autorisation pour le traitement
              des données personnelles utilisées à cette occasion. Nous renvoyons ici aussi à la présente
              déclaration de confidentialité. L’objectif de l’utilisation de cookies nécessaires sur le
              plan technique consiste à faciliter l’utilisation des sites Internet par les utilisateurs.
              Certaines fonctions de notre site Internet ne peuvent pas être proposées sans l’utilisation
              de cookies. Pour pouvoir utiliser ces fonctions, il faut que le navigateur puisse être
              identifié après un changement de site. Les données d’utilisateurs, prélevées par des cookies
              nécessaires sur le plan technique, ne sont pas utilisées à des fins de profilage. Les
              cookies d’analyse sont utilisés pour améliorer la qualité de notre site Internet et de ses
              contenus. Les cookies d’analyse nous apprennent comment le site Internet est utilisé afin de
              pouvoir optimiser notre offre en permanence. Ces objectifs justifient également nos intérêts
              légitimes en matière de traitement de données personnelles conformément à la base juridique
              aux termes de l’article 6 alinéa 1 lettre RGPD.&nbsp; Les cookies sont mémorisés sur
              l’ordinateur de l’utilisateur, qui les transmet à notre site Internet. En tant
              qu’utilisateur, vous gardez donc pleinement le contrôle de l’utilisation des cookies. Vous
              pouvez modifier les paramètres de votre navigateur Internet pour désactiver ou limiter la
              transmission de cookies. Les cookies mémorisés peuvent être effacés à tout moment. Cela peut
              également être effectué automatiquement. Si des cookies de notre site Internet sont
              désactivés, vous ne pourrez éventuellement pas utiliser intégralement toutes les fonctions
              du site Internet.</p>

            <p>2.1 Inscription<br/>
              Sur notre site Internet, nous proposons aux utilisateurs de s’inscrire en indiquant des
              données personnelles. Les données sont saisies dans un masque. Elles sont transmises à notre
              société, qui les mémorise. Les données ne sont pas transmises à des tiers. Les données
              suivantes sont prélevées dans le cadre de l’inscription :<br/>
              Les données suivantes sont mémorisées au moment de l’inscription :</p>

            <p>&nbsp;&nbsp;&nbsp; • L’adresse IP de l’utilisateur<br/>
              &nbsp;&nbsp;&nbsp; • La date et l’heure de l’inscription</p>

            <p>Dans le cadre de l’opération d’inscription, nous demandons l’autorisation de l’utilisateur
              pour le traitement de ces données. Les utilisateurs doivent s’inscrire pour la mise à
              disposition de certains contenus et de certaines prestations de service sur notre site
              Internet. Si l’utilisateur a donné son consentement, c’est l’article 6 alinéa 1 lettre a
              RGPD qui forme la base juridique correspondante.</p>

            <p>2.2 Formulaire de contact<br/>
              Notre site Internet propose un formulaire de contact, qui peut être utilisé pour contacter
              notre société électroniquement. Si un utilisateur fait usage de cette possibilité, les
              données saisies dans le masque sont transmises à notre société, qui les mémorise. Ces
              données sont les suivantes :<br/>
              Les données suivantes sont mémorisées lorsque le message est envoyé :</p>

            <p>&nbsp;&nbsp;&nbsp; • L’adresse IP de l’utilisateur<br/>
              &nbsp;&nbsp;&nbsp; • La date et l’heure de l’inscription</p>

            <p>Dans le cadre de l’opération d’envoi des données, nous demandons votre autorisation et
              renvoyons à la présente déclaration de confidentialité. Il est également possible de prendre
              contact avec notre société via l’adresse e-mail mise à disposition. Dans ce cas, les données
              personnelles de l’utilisateur, transmises dans l’e-mail, sont mémorisées. Ces données ne
              seront pas transmises à des tiers. Les données sont utilisées exclusivement pour le
              traitement de la conversation avec l’utilisateur. Le traitement des données personnelles,
              contenues dans le masque de saisie, sert uniquement au traitement de la prise de contact. En
              cas de prise de contact par e-mail, cela justifie également les intérêts légitimes pour le
              traitement de données. Les autres données personnelles, traitées pendant l’opération
              d’envoi, servent à empêcher une utilisation frauduleuse du formulaire de contact et à
              garantir la sécurité de nos systèmes d’information. Si l’utilisateur a donné son
              consentement, l’article 6 alinéa 1 lettre a RGPD forme la base juridique pour le traitement
              des données. L’article 6 alinéa 1 lettre f RGPD forme la base juridique pour le traitement
              des données, transmises dans le cadre de l’envoi d’un e-mail. Si le contact e-mail est
              destiné à la conclusion d’un contrat, l’article 6 alinéa 1 lettre b RGPD forme la base
              juridique supplémentaire pour le traitement. Les données sont effacées dès qu’elles ne sont
              plus nécessaires pour atteindre l’objectif pour lequel elles ont été prélevées. Pour les
              données personnelles figurant dans le masque de saisie du formulaire de contact et pour
              celles envoyées par e-mail, c’est le cas lorsque la conversation respective avec
              l’utilisateur est terminée. La conversation est terminée lorsque la situation fait ressortir
              que les faits concernés ont été définitivement tirés au clair. L’utilisateur peut à tout
              moment révoquer son autorisation pour le traitement des données personnelles avec effet dans
              le futur. Si l’utilisateur prend contact avec notre société par e-mail, il peut à tout
              moment s’opposer à la sauvegarde de ses données personnelles. Dans ce cas, la conversation
              ne peut pas être prorogée. Dans ce cas, toutes les données personnelles, mémorisées dans le
              cadre de la prise de contact, seront effacées.</p>

            <p>2.3 Outils de suivi<br/>
              Sur notre site Internet, nous utilisons Google Analytics comme outil de suivi et d’analyse
              dans le but d’augmenter l’efficacité de notre site Internet et du marketing direct. Cet
              outil est géré par des prestataires-tiers et nécessite la transmission de données concernant
              l’utilisateur du site Internet. Sur notre application, nous utilisons Matomo comme outil de
              suivi et d’analyse dans le but d’augmenter l’efficacité. Cet outil est d'augmenter
              l'efficacité de l'application et d'afficher l'inventaire. L’article 6 alinéa 1 lettre f RGPD
              forme la base juridique pour l’utilisation de l’analyse du site Internet et de
              l’application.</p>

            <p>2.4 Plug-ins de réseaux sociaux<br/>
              Sur notre site Internet, nous utilisons les plug-ins de réseaux sociaux suivants :</p>

            <p>&nbsp;&nbsp;&nbsp; • LinkedIn<br/>
              &nbsp;&nbsp;&nbsp; • XING</p>

            <p>La mise à disposition par principe des plug-ins sur notre site Internet résulte de nos
              intérêts légitimes à des fins marketing conformément à l’article 6 alinéa 1 lettre f
              RGPD.</p>

            <p>3. Base juridique pour le traitement de données personnelles<br/>
              Si nous demandons l’autorisation de la personne concernée pour les opérations de traitement
              de données personnelles, c’est l’article 6 alinéa 1 lettre a de l’ordonnance européenne sur
              la protection des données (RGPD) qui sert de base juridique pour le traitement des données
              personnelles. L’article 6 alinéa 1 lettre b RGPD forme la base juridique du traitement de
              données personnelles, nécessaires pour l’exécution d’un contrat, dont la partie contractante
              est la personne concernée. Cela s’applique également pour les opérations nécessaires pour
              l’exécution de mesures précontractuelles. Dans la mesure où le traitement de données
              personnelles est nécessaire pour remplir une obligation contractuelle incombant à notre
              société, c’est l’article 6 alinéa 1 lettre c RGPD qui sert de base juridique. Au cas où des
              intérêts vitaux de la personne concernée ou d’une autre personne physique nécessitent le
              traitement de données personnelles, c’est l’article 6 alinéa 1 lettre d RGPD qui sert de
              base juridique. Si le traitement est nécessaire pour faire valoir des intérêts légitimes de
              notre société ou d’un tiers et si les intérêts, droits fondamentaux et libertés
              fondamentales de la partie concernée ne priment pas les premiers intérêts cités, c’est
              l’article 6 alinéa 1 lettre f RGPD qui s’applique comme base juridique pour le traitement.
              Dans ce cas, nos intérêts légitimes, outre les objectifs suivants, sont :</p>

            <p>&nbsp;&nbsp;&nbsp; • La protection de l’entreprise contre des dommages matériels et
              immatériels<br/>
              &nbsp;&nbsp;&nbsp; • La professionnalisation de nos produits et prestations de service<br/>
              &nbsp;&nbsp;&nbsp; • L’optimisation des coûts.</p>

            <p>Nous traitons également des données personnelles pour répondre aux obligations de
              conservation commerciales ou fiscales. En ce qui concerne les exigences légales ou
              contractuelles prescrites, nous avons marqué les champs de saisie respectifs dans le masque
              de saisie, que vous devez obligatoirement remplir pour que nous puissions fournir les
              services souhaités.</p>

            <p>4. Effacement des données et durée de conservation<br/>
              Les données personnelles des personnes concernées sont effacées ou bloquées dès que
              l’objectif poursuivi par la mémorisation est caduc ou qu’il n’est plus nécessaire. Il se
              peut que nous conservions des données personnelles pour la période pendant laquelle des
              personnes pourraient faire valoir des droits contre notre société (les délais de
              prescription légaux peuvent aller de trois à trente ans). Nous pouvons en outre procéder à
              une mémorisation si c’est prévu par le législateur européen ou national dans le cadre
              d’ordonnances, de lois ou d’autres prescriptions de droit de l’Union européenne, auxquelles
              le responsable est soumis. Les obligations en matière de preuves et de conservation
              résultent entre autres du code du commerce, du code fiscal et de la loi sur le blanchiment
              d’argent. Les données de conservation sont ici de jusqu’à dix ans. Les données sont
              également bloquées ou effacées si un délai de conservation, prescrit par les normes citées,
              arrive à échéance, sauf s’il existe une nécessité de continuer à mémoriser les données pour
              la conclusion d’un contrat ou l’exécution d’un contrat.</p>

            <p>5. Droit d’opposition aux termes de l’article 21 RGPD<br/>
              Vous avez le droit, pour des raisons résultant de votre situation spécifique, de vous
              opposer à tout moment au traitement des données personnelles vous concernant, prélevées sur
              la base de l’article 6 alinéa 1 lettres e ou f RGPD. Cela s’applique également à un
              profilage basé sur ces dispositions. Le responsable ne traite plus les données personnelles
              vous concernant, sauf s’il peut justifier de motifs impérieux et légitimes pour le
              traitement, qui priment vos intérêts, droits et libertés ou si le traitement sert à faire
              valoir, exercer ou défendre des droits. Si les données personnelles vous concernant sont
              traitées pour faire de la publicité directe, vous êtes en droit de vous opposer à tout
              moment au traitement des données personnelles vous concernant à des fins de publicité de ce
              type. Cela s’applique également au profilage, dans la mesure où il est lié à une telle
              publicité directe. Si vous vous opposez au traitement à des fins de publicité directe, les
              données personnelles correspondantes ne sont plus traitées à ces fins. Dans le cadre de
              l’utilisation de services de la société de l’information, indépendamment de la directive
              2002/58/CE, vous avez la possibilité d’exercer votre droit d’opposition au moyen de
              procédures automatisées utilisant des spécifications techniques.</p>

            <p>6. Droits des personnes concernées<br/>
              Notre société attache une grande importance à la transparence de ses opérations relatives au
              traitement de données personnelles. Nous attirons donc votre attention sur le fait qu’outre
              le droit d’opposition, vous pouvez faire valoir d’autres droits si toutes les conditions
              légales requises sont remplies :</p>

            <p>&nbsp;&nbsp;&nbsp; • Droit à l’information aux termes de l’article 15 RGPD<br/>
              &nbsp;&nbsp;&nbsp; • Droit de rectification aux termes de l’article 16 RGPD<br/>
              &nbsp;&nbsp;&nbsp; • Droit à l’effacement (« Droit à l’oubli ») aux termes de l’article 17
              RGPD<br/>
              &nbsp;&nbsp;&nbsp; • Droit à la limitation du traitement aux termes de l’article 18
              RGPD<br/>
              &nbsp;&nbsp;&nbsp; • Droit à l’information aux termes de l’article 19 RGPD<br/>
              &nbsp;&nbsp;&nbsp; • Droit à la portabilité des données aux termes de l’article 20 RGPD<br/>
              &nbsp;&nbsp;&nbsp; • (Aucune) décision automatisée au cas par cas, profilage compris aux
              termes de l’article 21 RGPD</p>

            <p>Pour faire valoir vos droits, vous pouvez vous adresser par e-mail à l’adresse
              datenschutz@hensel-recycling.com. Afin de pouvoir traiter votre demande et à des fins
              d’identification, nous attirons votre attention sur le fait que nous traitons vos données
              personnelles conformément à l’article 6 alinéa 1 lettre c RGPD.</p>

            <p>7. Consentement<br/>
              Vous avez le droit de révoquer à tout moment votre déclaration de consentement concernant la
              protection des données avec effet pour le futur. La révocation de l’autorisation n’affecte
              en rien la légalité du traitement effectué sur la base de l’autorisation avant la
              révocation. Dans certains cas, nous sommes en droit de continuer à traiter vos données
              personnelles malgré votre révocation, et ce sur une base juridique différente (pour exécuter
              un contrat).</p>

            <p>8. Droit de recours auprès de l’autorité de tutelle<br/>
              Sans préjudice d’un autre recours administratif ou juridique, vous êtes en droit de porter
              plainte auprès de l’autorité de tutelle, en particulier dans l’État membre de votre lieu de
              résidence, de travail ou de l’infraction supposée si vous êtes d’avis que le traitement des
              données personnelles vous concernant viole les dispositions du RGPD. L’autorité de tutelle,
              auprès de laquelle le recours a été déposé, informe le plaignant de l’état et des résultats
              de la plainte ainsi que de la possibilité des voies de recours juridiques aux termes de
              l’article 78 RGPD.<br/>
              Autorité de tutelle compétente :</p>

            <p>Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)<br/>
              Promenade 27<br/>
              D-91522 Ansbach</p>

          </div>
        </bulma-accordion-item>
        <bulma-accordion-item>
          <h4 slot="title" style="padding-right: .5em">Condiciones de uso para descargar y utilizar la
            aplicación de catálogo</h4>
          <div slot="content">
            <h3>Declaración</h3>

            <p>Por la presente autorizo a Hensel Recycling GmbH (HR) la recopilación, tratamiento y uso de
              información sobre mi uso de las aplicaciones de este catálogo. Dicha información incluye mi
              nombre de usuario. HR tratará esta información de forma confidencial y no la divulgará a
              terceros. Esto no se aplicará si HR está obligada a revelar los datos por ley o en el
              contexto de procedimientos judiciales. Soy consciente de que HR utilizará los datos
              recogidos con los siguientes fines:</p>

            <p>- para combatir el uso indebido, en particular para rastrear cualquier robo de datos y toda
              divulgación no autorizada de datos de acceso (nombre de usuario y contraseña);<br/>
              - para mejorar el contacto con el cliente, en particular registrando el tipo y el número de
              catalizadores en los que se manifiesta un interés;<br/>
              - para mejorar el sitio web.</p>

            <p>Puedo revocar este consentimiento en cualquier momento con efecto a plazo. Puedo exigir que
              los datos ya recogidos sean borrados o bloqueados, siempre que dichos datos no sean
              necesarios en ninguna relación comercial en curso, y siempre que hacerlo no incurre en
              tiempo y costes irrazonables para HR.</p>

            <h4>Condiciones de uso para descargar y utilizar la aplicación de catálogo</h4>

            <p>1. Introducción<br/>
              El contenido de esta aplicación de catálogo ha sido compilado por Hensel Recycling GmbH
              (referida a continuación como “HR”) con el mayor cuidado posible. Sin embargo, no podemos
              garantizar que la información sea completa y correcta. Por lo tanto HR no asumirá ninguna
              responsabilidad por errores en el contenido. Al acceder a la aplicación de catálogo, Usted
              acepta incondicionalmente los siguientes términos de uso sin restricciones.</p>

            <p>2. Derechos de propiedad intelectual<br/>
              Las ilustraciones y el contenido son nuestra propiedad intelectual y están protegidos por
              derechos de autor. Por consiguiente, no podrán ser copiados, distribuidos, adaptados o
              procesados en otros medios, incluso por medios electrónicos. Se requiere el consentimiento
              previo por escrito de parte de HR para cada uso del contenido. HR puede revocar el uso de la
              aplicación de catálogo en cualquier momento, sin indicar los motivos.</p>

            <p>3. Responsabilidad<br/>
              Toda la información proporcionada ha sido recopilada según nuestro conocimiento; no se puede
              garantizar la actualización continua de los datos. Se excluyen, por tanto, las reclamaciones
              de indemnización de los clientes por información incorrecta. Cualquier oferta y confirmación
              de pedido, que se emiten sobre la base de datos incorrectos proporcionados por el cliente,
              serán anuladas. Al dar su consentimiento a estos Términos de Uso, el usuario acepta
              expresamente que la categoría determinada por nuestros empleados será decisiva para
              determinar el valor final. Al cargar catalizadores basados en categorías, se aplicará la
              categoría determinada en la fecha en que se realice el pedido.</p>

            <h3>Declaración de protección de datos según el Reglamento General de Protección de Datos
              (RGPD)</h3>

            <p>1. Nombre y dirección de la persona responsable<br/>
              El responsable en el sentido del Reglamento de Base de Protección de Datos y otras leyes
              nacionales de protección de datos de los Estados miembros, así como otras regulaciones de
              protección de datos es la empresa:</p>

            <p>Hensel Recycling GmbH<br/>
              Mühlweg 10<br/>
              D-63743 Aschaffenburg<br/>
              Alemania<br/>
              Tlf.: +49 6028 1209-0<br/>
              Correo electrónico: info@hensel-recycling.com<br/>
              Página web: <a href="http://www.hensel-recycling.com">www.hensel-recycling.com</a></p>

            <p>A continuación, le informamos sobre el tratamiento de sus datos personales en el marco de la
              utilización de nuestra página web. Si tiene más preguntas sobre la protección de datos en
              relación con nuestra página web o los servicios ofrecidos, póngase en contacto con nuestro
              responsable de protección de datos.<br/>
              El encargado de la protección de datos de la empresa responsable es:</p>

            <p>Rudolf Fiedler<br/>
              DPP Data Protection GmbH<br/>
              Correo electrónico: datenschutz@hensel-recycling.com</p>

            <p>2. Alcance, finalidad y fundamento jurídico del tratamiento de datos personales<br/>
              Solo recogemos y utilizamos los datos personales de nuestros usuarios en la medida en que
              sea necesario para proporcionar un sitio web funcional, así como nuestros contenidos y
              servicios. La obtención y el uso de los datos personales de nuestros usuarios se lleva a
              cabo regularmente solo con el consentimiento del usuario. Se aplicará una excepción en los
              casos en que no pueda obtenerse el consentimiento previo por razones reales y el tratamiento
              de los datos esté permitido por la ley.</p>

            <p>2.1 Creación de archivos de registro<br/>
              Cada vez que visita nuestro sitio web, nuestro sistema recopila automáticamente datos e
              información del sistema informático del ordenador que realiza la visita.<br/>
              Se recogen los siguientes datos (“información técnica”):</p>

            <p>&nbsp;&nbsp;&nbsp; • Información sobre el tipo de navegador y la versión utilizada<br/>
              &nbsp;&nbsp;&nbsp; • El sistema operativo del usuario<br/>
              &nbsp;&nbsp;&nbsp; • El proveedor de servicios de Internet del usuario<br/>
              &nbsp;&nbsp;&nbsp; • La dirección IP del usuario de forma anónima<br/>
              &nbsp;&nbsp;&nbsp; • Fecha y hora de acceso<br/>
              &nbsp;&nbsp;&nbsp; • Sitios desde los que el sistema del usuario ha accedido a nuestro sitio
              web.<br/>
              &nbsp;&nbsp;&nbsp; • Sitios web a los que accede el sistema del usuario a través de nuestro
              sitio web</p>

            <p>Los datos también se almacenan en los archivos de registro de nuestro sistema. No se verán
              afectadas las direcciones IP del usuario u otros datos que permitan la asignación de los
              datos al usuario. Estos datos no se almacenan junto con otros datos personales del usuario.
              Procesamos esta información técnica con fines de seguridad de la red, por ejemplo, para
              combatir ataques, con fines de marketing, para comprender mejor las necesidades de nuestros
              usuarios y para mejorar nuestra oferta de sitios web. Es en estos fines donde también reside
              nuestro verdadero interés, en el procesamiento de datos según el artículo 6, párrafo 1,
              letra f) del Reglamento alemán de Base sobre la Protección de Datos. Es absolutamente
              necesario para el funcionamiento del sitio web recopilar datos para la preparación del sitio
              web y almacenarlos en archivos de registro. Por lo tanto, no hay posibilidad de objeción por
              parte del usuario.</p>

            <p>2.2 Uso de cookies<br/>
              Nuestro sitio web utiliza cookies. Las cookies son archivos de texto que se almacenan en el
              sistema informático del usuario ya sea en el navegador de Internet o desde el navegador de
              Internet. Si un usuario visita un sitio web, puede almacenarse una cookie en el sistema
              operativo del usuario. Esta cookie contiene una cadena de caracteres característica que
              permite una identificación única del navegador cuando se vuelve a entrar en el sitio web.
              Utilizamos cookies para que nuestro sitio web sea más fácil de usar. Algunos elementos de
              nuestro sitio web requieren que el navegador que accede pueda ser identificado incluso
              después de un cambio de página. Además, en nuestro sitio web utilizamos cookies que permiten
              un análisis del comportamiento de navegación del usuario. Los datos de usuario recogidos de
              esta manera se someten a una seudonomización gracias a un proceso técnico. Por lo que no es
              posible asignar los datos al usuario que realiza la visita. Los datos no serán almacenados
              junto con otros datos personales de usuario. Cuando usted visita nuestro sitio web, un
              anuncio banner le informará sobre el uso de cookies con fines analíticos y le remitirá a
              esta declaración de protección de datos. Al acceder a nuestro sitio web, se informará al
              usuario sobre el uso de cookies con fines analíticos y se obtendrá su consentimiento para el
              tratamiento de los datos personales utilizados en este sentido. En este contexto, también se
              hará referencia a esta declaración de protección de datos. La utilización de las cookies
              necesarias desde el punto de vista técnico tiene por objeto facilitar el uso de las páginas
              web por parte de los usuarios. Algunas funciones de nuestro sitio web no se pueden ofrecer
              sin el uso de cookies. Para ello es necesario que se reconozcan el navegador incluso después
              de un cambio de página. Los datos de usuario recogidos por las cookies, necesarias a nivel
              técnico, no se utilizan para crear perfiles de usuario. Las cookies de análisis se utilizan
              para mejorar la calidad y contenido de nuestro sitio web. A través de las cookies de
              análisis descubrimos cómo se utiliza el sitio web y así podemos seguir optimizando nuestra
              oferta. Es en estos fines donde reside nuestro verdadero interés, en el tratamiento de datos
              personales y también la base jurídica de acuerdo con el artículo 6, párrafo 1, letra f) del
              Reglamento General de Protección de Datos. Las cookies se almacenan en el ordenador del
              usuario y se transmiten a nuestra página. Por lo tanto, usted como usuario también tiene
              control total sobre el uso de cookies. Usted puede desactivar o restringir la transmisión de
              cookies, cambiando la configuración de su navegador de Internet. En todo momento se pueden
              borrar las cookies que ya han sido guardadas. Esto también se puede hacer automáticamente.
              Si se desactivan las cookies para nuestro sitio web, es posible que ya no sea posible
              utilizar todas las funciones del sitio web en su totalidad.</p>

            <p>2.1 Registrarse<br/>
              En nuestro sitio web ofrecemos a los usuarios la oportunidad de registrarse, proporcionando
              sus datos personales. Los datos se introducen en una máscara de entrada, se nos transmiten y
              se guardan. Los datos no pasarán a terceros. Los siguientes datos se recogen durante el
              proceso de registro:<br/>
              En el momento del registro, también se almacenan los siguientes datos:</p>

            <p>&nbsp;&nbsp;&nbsp; • La dirección IP del usuario<br/>
              &nbsp;&nbsp;&nbsp; • Fecha y hora de registro</p>

            <p>Durante el proceso de registro se obtiene el consentimiento del usuario para el tratamiento
              de estos datos. Es necesario que el usuario se registre para disfrutar de determinados
              contenidos y servicios de nuestro sitio web. La base legal para el tratamiento de datos es
              el artículo 6, párrafo 1 letra a) del RGPD si el usuario ha dado su consentimiento.</p>

            <p>2.2 Formulario de contacto<br/>
              En nuestra en página web hay un formulario de contacto que se puede utilizar para
              contactarnos por correo electrónico. Si el usuario acepta esta posibilidad, los datos
              introducidos en la máscara de entrada nos serán transmitidos y almacenados. Estos datos son:<br/>
              En el momento en que se envía el mensaje, también se almacenan los siguientes datos:</p>

            <p>&nbsp;&nbsp;&nbsp; • La dirección IP del usuario<br/>
              &nbsp;&nbsp;&nbsp; • Fecha y hora de registro</p>

            <p>Se solicitará su consentimiento para el tratamiento de los datos en el marco del proceso de
              envío y se hará referencia a esta declaración de protección de datos. También puede ponerse
              en contacto con nosotros a través de la dirección de correo electrónico que se le facilita.
              En este caso, se almacenarán los datos personales del usuario facilitados por correo
              electrónico. En este contexto, los datos no serán cedidos a terceros. Los datos se utilizan
              exclusivamente para procesar la conversación. El tratamiento de los datos personales de la
              máscara de entrada nos sirve solo para gestionar la toma de contacto. En caso de haber
              contacto por correo electrónico, se debe entender también que el verdadero interés radica en
              que esto es necesario para el tratamiento de los datos. Los demás datos personales
              utilizados durante el proceso de envío sirven para evitar el uso indebido del formulario de
              contacto y para garantizar la seguridad de nuestros sistemas informáticos. La base legal
              para el tratamiento de datos es el artículo 6, párrafo 1 letra a) del RGPD, si el usuario ha
              dado su consentimiento. El fundamento jurídico para el tratamiento de los datos transmitidos
              durante el envío de un correo electrónico es el artículo 6, párrafo 1, letra f) del RGPD. Si
              el contacto por correo electrónico tiene por objeto formalizar un contrato, entonces la base
              jurídica adicional para el tratamiento es el artículo 6 párrafo 1 letra b) del RGPD. Los
              datos serán eliminados tan pronto como dejen de ser necesarios para cumplir la finalidad
              para la que fueron recogidos. Este es el caso una vez hayamos finalizado la correspondiente
              conversación con el usuario en relación a los datos personales de la máscara de entrada del
              formulario de contacto y a los datos enviados por correo electrónico, La conversación
              termina cuando se puede deducir de las circunstancias que los hechos en cuestión por fin han
              sido aclarados. El usuario tiene la posibilidad en todo momento de revocar su consentimiento
              sobre el tratamiento de datos personales con efecto para el futuro. Si el usuario se pone en
              contacto con nosotros por correo electrónico, puede oponerse en todo momento a que se
              almacenen sus datos personales. En tal caso, la conversación no podrá continuar. Serán
              eliminados todos los datos personales almacenados durante el contacto mantenido con
              nosotros.</p>

            <p>2.3 Herramientas de seguimiento<br/>
              En nuestro sitio web utilizamos Google Analytics como herramienta de seguimiento y análisis
              de sitios web. El objetivo es aumentar la eficiencia de nuestro sitio web y el marketing
              directo. Esta herramienta es operada por terceros y requiere la transferencia de datos sobre
              los visitantes del sitio web. En nuestro App utilizamos Matomo como herramienta de
              seguimiento y análisis. El objetivo es aumentar la eficiencia de nuestro App y la
              representación de la cesta. Estas herramientas son operadas por terceros y requieren la
              transferencia de datos sobre los visitantes del sitio web y App.La base jurídica para el uso
              del análisis del sitio web es el artículo 6, párrafo 1, letra f) del RGPD.</p>

            <p>2.4 Complementos de redes sociales<br/>
              En nuestro sitio web utilizamos los siguientes complementos de redes sociales:</p>

            <p>&nbsp;&nbsp;&nbsp; • LinkedIn<br/>
              &nbsp;&nbsp;&nbsp; • XING</p>

            <p>En principio, la puesta a disposición de complementos en nuestro sitio web promueve la
              consecución de nuestro legítimo interés con fines de marketing del artículo 6, párrafo 1
              letra f) del RGPD.</p>

            <p>3. Base jurídica para el tratamiento de datos personales<br/>
              En la medida en que obtengamos el consentimiento del interesado para el tratamiento de datos
              personales, el artículo 6, párrafo 1 letra a) del Reglamento General de Protección de Datos
              de la UE (RGPD) sirve como base legal para el tratamiento de datos personales. En el
              tratamiento de los datos personales necesarios para la ejecución de un contrato en el que el
              interesado es parte, sirve de base jurídica el artículo 6, párrafo 1, letra b), del RGPD.
              Esto también se aplica a las operaciones de tratamiento que son necesarias para llevar a
              cabo medidas precontractuales. En la medida en que el tratamiento de datos personales sea
              necesario para cumplir una obligación legal a la que está sujeta nuestra empresa, sirve de
              base jurídica el artículo 6, párrafo 1, letra c), del RGPD. En caso de que los intereses
              vitales del interesado o de otra persona física requieran el tratamiento de datos
              personales, sirve de base jurídica el artículo 6, párrafo 1, letra d), del RGPD. Si el
              tratamiento es necesario para salvaguardar un interés legítimo de nuestra empresa o de un
              tercero y si los intereses, los derechos y las libertades fundamentales del interesado no
              prevalecen sobre el interés mencionado en primer lugar, sirve de base jurídica para el
              tratamiento el artículo 6, párrafo 1, letra f), del RGPD. En este caso, nuestros intereses
              legítimos se suman a los fines antes mencionados:</p>

            <p>&nbsp;&nbsp;&nbsp; • Protección de la empresa contra daños materiales o inmateriales<br/>
              &nbsp;&nbsp;&nbsp; • La profesionalización de nuestros productos y servicios<br/>
              &nbsp;&nbsp;&nbsp; • Optimización de costes.</p>

            <p>Además, procesamos los datos personales con el fin de cumplir con las obligaciones
              comerciales o fiscales de conservación de datos. Para cumplir con los requisitos legales o
              contractuales, hemos marcado los respectivos campos de entrada en las máscaras de entrada de
              nuestro sitio web, que usted debe rellenar para que podamos proporcionarle el servicio que
              necesita.</p>

            <p>4. Eliminación de datos y tiempo de almacenamiento<br/>
              Se eliminarán o bloquearán los datos personales del interesado tan pronto como no proceda o
              deje de ser necesaria la finalidad del almacenamiento. Puede ocurrir que los datos
              personales se almacenen durante el período durante el cual se puedan presentar reclamaciones
              contra nuestra empresa (los plazos de prescripción legales pueden oscilar entre tres y
              treinta años). Además, los datos podrán almacenarse si así lo ha previsto el legislador
              europeo o nacional en reglamentos, leyes u otras disposiciones de la UE a las que esté
              sujeta la persona o empresa responsable. El Código de Comercio alemán, el Código Fiscal y la
              Ley de Blanqueo de Capitales, entre otros, imponen las correspondientes obligaciones de
              comprobación y conservación. Los períodos de almacenamiento son de hasta diez años. Los
              datos también serán bloqueados o eliminados si expira el período de almacenamiento prescrito
              por las normas antes mencionadas, a menos que haya la necesidad de almacenar adicionalmente
              los datos para concluir o cumplir el contrato.</p>

            <p>5. Derecho de oposición con arreglo al artículo 21 del RGPD<br/>
              Usted tiene derecho a oponerse en todo momento, por razones que se deriven de su situación
              particular, al tratamiento de los datos personales que le conciernen en virtud del artículo
              6, párrafo 1, letras e) o f), del RGPD; esto también se aplica a la elaboración de perfiles
              basada en estas disposiciones. El responsable del tratamiento deja de tratar los datos
              personales que le conciernen, a menos que pueda demostrar que existen razones imperiosas y
              merecedoras de protección para el tratamiento, que superen sus intereses, derechos y
              libertades, o que el tratamiento sirva para hacer valer, ejercer o defender derechos
              legales. Si los datos personales que le conciernen se procesan con fines de marketing
              directo, usted tiene derecho a oponerse en todo momento al procesamiento de los datos
              personales que le conciernen con el fin de dicha publicidad; esto también se aplica a la
              elaboración de perfiles, en la medida en que esté asociada con dicho marketing directo. Si
              usted se opone al tratamiento con fines de marketing directo, los datos personales que le
              conciernen ya no se tratarán para estos fines. Usted tiene la posibilidad de ejercer su
              derecho de oposición en relación con el uso de los servicios de la sociedad de la
              información mediante procedimientos automatizados que utilizan especificaciones técnicas, a
              pesar de lo dispuesto en la Directiva 2002/58/CE.</p>

            <p>6. Derechos del interesado<br/>
              Para nuestra empresa es muy importante que nuestros procesos de tratamiento de datos
              personales sean transparentes. Por lo que queremos señalar que, además del derecho de
              oposición, usted puede ejercer otros derechos si se cumplen los correspondientes requisitos
              legales:</p>

            <p>&nbsp;&nbsp;&nbsp; • Derecho a la información según el artículo 15 del RGPD<br/>
              &nbsp;&nbsp;&nbsp; • Derecho de rectificación según el artículo 16 del RGPD<br/>
              &nbsp;&nbsp;&nbsp; • Derecho de eliminación (“derecho a ser olvidado”) según el artículo 17
              del RGPD<br/>
              &nbsp;&nbsp;&nbsp; • Derecho a la limitación del tratamiento según el artículo 18 del
              RGPD<br/>
              &nbsp;&nbsp;&nbsp; • Derecho a informar según el artículo 19 del RGPD<br/>
              &nbsp;&nbsp;&nbsp; • Derecho a la transferencia de datos según el artículo 20 del RGPD<br/>
              &nbsp;&nbsp;&nbsp; • (ninguna) decisión automatizada en casos individuales, incluida la
              elaboración de perfiles según el artículo 21 del RGPD</p>

            <p>Para ejercer sus derechos, puede ponerse en contacto con nosotros por correo electrónico
              datenschutz@hensel-recycling.com. Con el fin de procesar su solicitud y con fines de
              identificación, nos gustaría señalar que procesamos sus datos personales de conformidad con
              el artículo 6, párrafo 1, letra c), del RGPD.</p>

            <p>7. Consentimiento<br/>
              Usted tiene el derecho a revocar su declaración de consentimiento de protección de datos en
              todo momento con efecto para el futuro. La revocación del consentimiento no afectará a la
              legalidad del tratamiento realizado sobre la base del consentimiento hasta la revocación. En
              algunos casos, a pesar de la revocación, estamos autorizados a seguir procesando sus datos
              personales sobre otra base legal (para cumplir con un contrato).</p>

            <p>8. Derecho de recurso ante una autoridad de control<br/>
              Sin perjuicio de cualquier otro recurso administrativo o judicial, usted tiene derecho a
              recurrir ante una autoridad de control, en particular en el Estado miembro en el que resida,
              trabaje o sospeche que se ha cometido una infracción, si considera que el tratamiento de los
              datos personales que le conciernen es contrario al RGPD. La autoridad de control ante la que
              se haya presentado la reclamación informará al reclamante de la situación y los resultados
              de la misma, incluida la posibilidad de interponer un recurso judicial con arreglo al
              artículo 78 del RGPD.<br/>
              Autoridad supervisora competente:</p>

            <p>Oficina Estatal de Supervisión de Protección de Datos de Baviera (BayLDA)<br/>
              Promenade 27<br/>
              D-91522 Ansbach (Alemania)</p>

          </div>
        </bulma-accordion-item>
      </bulma-accordion>
    </modal>

    <canvas ref="myCanvas" class="hidden" width="1000"
            height="750"></canvas>
  </div>
</template>

<script>
import { detect } from 'detect-browser'

import { mapActions, mapMutations, mapState } from 'vuex'
import { bottomNavRoutes } from './router'
import cdvStore from './mixins/cdvStore.js'
import Modal from './components/Modal'
import Navigation from './components/Navigation'
import BottomNavigation from './components/BottomNavigation'
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
import MenuComp from '@/views/Menu'
import System from '@/_system.js'

export default {
  name: 'App',
  components: { MenuComp, BulmaAccordion, BulmaAccordionItem, BottomNavigation, Navigation, Modal },
  mixins: [cdvStore],
  data () {
    return {
      lgMenuOpen: false,
      mounted: false,
      isiOS: false,
      lastFailedBiometricAuth: null,
    }
  },
  computed: {
    ...mapState({
      authToken: state => state.Api.authToken,
      apiVersion: state => state.apiVersion,
      user: state => state.Api.Users.current,
      latestError: state => state.latestError,
      modalConverter: state => state.Api.Inventory.modalConverter,
      inventory: state => state.Api.Inventory.current,
      availableLanguages: state => state.Api.Localizations.all,
    }),
    bottomNavRoutes () {
      return bottomNavRoutes
    },
    latestErrorHidden () {
      return this.latestError.hidden
    },
  },
  methods: {
    ...mapActions({
      addInventory: 'Api/Inventory/add',
      refreshInventory: 'Api/Inventory/get',
      fetchImage: 'Api/Images/get',
      login: 'Api/Users/login',
      logout: 'Api/Users/logout',
      getUserInfo: 'Api/Users/info',
      fetchLocalizations: 'Api/Localizations/get',
      fetchAttributes: 'Api/Converters/attributes',
      acceptTerms: 'Api/Users/acceptTerms',
    }),
    ...mapMutations({
      setModalConverter: 'Api/Inventory/setModalConverter',
      setApiBaseUrl: 'Api/setApiBaseUrl',
      setAuthToken: 'Api/setAuthToken',
    }),
    async detectIos () {
      const browser = detect()

      if (browser && browser.name === 'safari') {
        this.isiOS = true

        return
      }

      const system = await System.getDevicePlatformOption()

      this.isiOS = system === 'ios'
    },
    onPause () {
      localStorage.setItem('onPauseTimeStamp', +new Date() + '')
    },
    async detectLanguage (user = null) {
      try {
        const lang = await this.$localforage.getItem(process.env.VUE_APP_LANGUAGE_STORE_KEY)

        if (lang && this.availableLanguages.includes(lang)) {
          return lang
        }
      } catch (e) {
        console.error(e)
      }

      if (user?.culture_name) {
        const lang = user.culture_name.split('-').shift()

        if (lang?.length === 2 && this.availableLanguages.includes(lang)) {
          return lang
        }
      } else {
        const lang = (window.navigator?.language || window.navigatorLanguage)?.substring?.(0, 2)
        if (lang && this.availableLanguages.includes(lang)) {
          return lang
        }
      }

      return 'en'
    },
    async onResume () {
      const now = +new Date()

      // Handle the resume event
      const onPauseTimeStamp = localStorage.getItem('onPauseTimeStamp')
      localStorage.removeItem('onPauseTimeStamp')

      if (onPauseTimeStamp && onPauseTimeStamp <
          (now - this.$config.LOGOUT_TIMER_IN_MINUTES * 60_000)) {
        try {
          await this.logout()
        } catch (e) {
          this.apiErrorHandler(e)
        } finally {
          this.$router.push('/', () => null, () => null)
        }
      }

      try {
        const saveCredentials = await this.$localforage.getItem('saveCredentials')
        if (saveCredentials) {
          const storedToken = await this.$localforage.getItem(process.env.VUE_APP_AUTH_TOKEN_STORAGE_KEY)

          if (this.$router.currentRoute.path === '/' && storedToken) {
            //login using saved credentials
            const lastAutoLogin = localStorage.getItem('autoLoginLock')
            localStorage.removeItem('autoLoginLock')

            if (
                await System.biometryAvailable()
                && (this.lastFailedBiometricAuth === null || parseInt(this.lastFailedBiometricAuth) + 60_000 < now)
            ) {
              await this.authenticateUsingFingerprint()
            } else if (!lastAutoLogin || parseInt(lastAutoLogin) + 60_000 < now) {
              localStorage.setItem('autoLoginLock', now + '')
              await this.fingerprintSuccessCallback()
            }
          }
        }
      } catch (e) {
        console.error(e)
      }

      try {
        if (this.authToken) {
          const userInfo = await this.getUserInfo()

          const lang = await this.detectLanguage(userInfo)

          await this.fetchLocalizations({ language: lang })
          await this.$localforage.setItem(process.env.VUE_APP_LANGUAGE_STORE_KEY, lang)
        } else {
          const lang = await this.detectLanguage()

          await this.fetchLocalizations({ language: lang })
        }
      } catch (err) {
        this.apiErrorHandler(err)
      }

      this.mounted = true
    },
    async authenticateUsingFingerprint (type) {
      try {
        const storedToken = await this.$localforage.getItem(process.env.VUE_APP_AUTH_TOKEN_STORAGE_KEY)
        if (!storedToken) {
          // Don't show the dialog / regular login
          return false
        }

        const options = {
          clientId: 'KATalog mobile Token',
          clientSecret: '9meQiB8F4YY3xnEHb7MJxWPrpzXYX2Q', //Only necessary for Android
        }

        const localizedReason = this._('perform auto login')
        if (localizedReason) {
          options.reason = localizedReason
        }

        const localizedFallbackTitle = this._('localized-fallback-title-' + type)
        if (localizedFallbackTitle) {
          options.title = localizedFallbackTitle
        }

        const verified = await System.biometricVerify(options)

        if (verified) {
          await this.fingerprintSuccessCallback()
        } else {
          await this.fingerprintErrorCallback()
        }
      } catch (e) {
        console.error(e)
      }
    },
    async fingerprintSuccessCallback () {
      try {
        this.lastFailedBiometricAuth = null

        const storedToken = await this.$localforage.getItem(process.env.VUE_APP_AUTH_TOKEN_STORAGE_KEY)

        this.setAuthToken(storedToken)
        await this.login({ token: storedToken })

        const uuid = await this.$localforage.getItem('deviceUUID')
        if (uuid) {
          window.initMatomo(uuid)
        }

        await this.fetchAttributes()

        this.$router.push('/home', () => null, () => null)

      } catch (err) {
        console.error('FingerprintSuccessCallback', err)
        this.apiErrorHandler(err)
      }
    },
    fingerprintErrorCallback (err) {
      this.lastFailedBiometricAuth = new Date()

      console.error(err)
    },
    handleScreenOrientationLock () {
      const screenWidth = document.body.clientWidth
      if (screenWidth < 768) {
        System.lockScreenOrientation('portrait')
      } else {
        System.unlockScreenOrientation()
      }
    },
    processImage (user, file, callback) {
      if (!file || !user) {
        return
      }

      this.fetchImage({ id: file })
          .then(result => {
            this.canvasDrawImage(result, user, file, callback)
          })
          .catch(this.apiErrorHandler)
    },
    canvasDrawImage (blob, userId, file, callback) {
      const canvas = this.$refs.myCanvas
      const ctx = canvas.getContext('2d')
      const img = new Image()

      img.onload = async () => {
        canvas.width = img.naturalWidth
        canvas.height = img.naturalHeight

        const imageScale = this.getScaledImage(canvas, img)

        ctx.drawImage(img, imageScale.x, imageScale.y, imageScale.width, imageScale.height)

        ctx.font = '17px Arial'
        ctx.strokeStyle = 'rgba(33,33,33,1)'
        ctx.fillStyle = 'rgba(60,60,60, .6)'
        ctx.shadowColor = 'rgba(180,180,180, .7)'

        ctx.shadowOffsetX = -2
        ctx.shadowOffsetY = -1

        ctx.globalCompositeOperation = 'luminosity'

        const textSize = ctx.measureText(userId)

        ctx.fillText(userId, (imageScale.width - textSize.width) / 2, (imageScale.height * .5) + 100,
            imageScale.width - (imageScale.width * .1))

        const imageData = canvas.toDataURL()

        callback(imageData)

        ctx.globalCompositeOperation = 'source-over'
        ctx.clearRect(0, 0, canvas.width, canvas.height)

        await this.writeFile(`${userId}-${file}.dat`, imageData)
      }

      img.src = URL.createObjectURL(blob)
    },
    getScaledImage (canvas, image) {
      const scaleW = canvas.width / image.naturalWidth
      const scaleH = canvas.height / image.naturalHeight

      const scale = Math.min(scaleW, scaleH)

      const scaledWidth = image.naturalWidth * scale
      const scaledHeight = image.naturalHeight * scale

      let x = 0, y = 0

      if (canvas.width > scaledWidth) {
        x = (canvas.width - scaledWidth) / 2
      } else {
        y = (canvas.height - scaledHeight) / 2
      }

      return {
        width: scaledWidth,
        height: scaledHeight,
        x: x,
        y: y,
      }
    },
    async removeFromInventory () {
      const converters = this.inventory.inventory_converters.slice()
      const idx = converters.findIndex(el => el.converter_id === this.modalConverter.id)
      if (idx > -1) {
        converters.splice(idx, 1)
      }

      if (!this.user) {
        try {
          await this.getUserInfo()
        } catch (e) {
          return this.apiErrorHandler(e)
        }
      }

      this.addInventory({
        currency_id: this.user.currency_id,
        inventory_converters: converters,
      })
          .then(result => {
            this.setModalConverter(null)
            this.refreshInventory(result)
                .catch(this.apiErrorHandler)
          })
          .catch(this.apiErrorHandler)
    },
    hideConfirmationModal () {
      this.setModalConverter(null)
    },
    tryAcceptTerms () {
      this.acceptTerms()
          .catch(this.apiErrorHandler)
    },
  },
  async created () {
    if (typeof this.onPause === 'function') {
      document.addEventListener('pause', this.onPause, false)
    }

    if (typeof this.onResume === 'function') {
      document.addEventListener('resume', this.onResume, false)
    }

    this.handleScreenOrientationLock()

    await System.showKeyboardAccessoryBar(false)
    await System.setStatusBarStyle('LIGHT')

    const hideAccessForm = !!JSON.parse(sessionStorage.getItem('hideAccessForm'))
    this.$store.commit('hideAccessForm', hideAccessForm)

    const storedToken = sessionStorage.getItem(process.env.VUE_APP_AUTH_TOKEN_STORAGE_KEY)
    if (storedToken) {
      this.setAuthToken(storedToken)
    }

    this.$router.beforeEach((to, from, next) => {
      if (to.meta?.requiresAuth && !this.user) {
        next({ name: 'Login' })
      } else {
        next()
      }
    })
  },
  mounted () {
    this.onResume()

    this.detectIos()
  },
  beforeDestroy () {
    if (typeof this.onPause === 'function') {
      document.removeEventListener('pause', this.onPause)
    }

    if (typeof this.onResume === 'function') {
      document.removeEventListener('resume', this.onResume)
    }
  },
}
</script>

<style src="@/styles/main.scss" lang="scss">
</style>
